// import React, { useState, useEffect } from "react";
// import { 
//   Home, List, Logout, Map, Print, Report, Handshake,
//   SettingsAccessibility, CheckCircle, Warning, Error,
//   Description, Save, Assignment, Verified, Person,
//   BusinessCenter, CalendarToday, SquareFoot,
//   LocationOn, ElectricalServices, Edit, Download
// } from "@mui/icons-material";
// import {
//   Box,
//   Paper,
//   Typography,
//   InputLabel,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Chip,
//   IconButton,
//   Button,
//   TextField,
//   MenuItem,
//   Select,
//   FormControl,
//   Divider,
//   Grid,
//   Card,
//   CardContent,
//   Tabs,
//   Tab,
//   AppBar,
//   Toolbar,
//   Container,
//   CircularProgress,
//   Input
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// // Import your custom components
// import FormContainer from "../../../../components/Forms/FormContainer";
// import useDecodedUser from "../../../../services/hooks/useDecodedUser";
// import { ExecutePostWithParams } from "../../../../services/api/ExecuteApiRequests";
// import { IPDCFormattedJsonToDisplay } from "../../../../components/Controls";
// import { GetDataFromApiWithParams } from "../../../../services/api/ExecuteApiRequests";

// // ========== STYLED COMPONENTS ==========
// const TimesTextField = styled(TextField)(({ theme }) => ({
//   '& .MuiInputBase-root': {
//     fontFamily: '"Times New Roman", Times, serif',
//     fontSize: '0.875rem',
//     fontWeight: 400,
//   },
//   '& .MuiInputLabel-root': {
//     fontFamily: '"Times New Roman", Times, serif',
//     fontSize: '0.875rem',
//     fontWeight: 400,
//   },
//   '& .MuiOutlinedInput-root': {
//     '& fieldset': { borderWidth: '1px' },
//     '&:hover fieldset': { borderWidth: '1px' },
//     '&.Mui-focused fieldset': { borderWidth: '1px' },
//   },
// }));

// const TimesTypography = styled(Typography)(({ theme }) => ({
//   fontFamily: '"Times New Roman", Times, serif !important',
// }));

// const TimesInput = styled(Input)(({ theme }) => ({
//   '& .MuiInputBase-input': {
//     fontFamily: '"Times New Roman", Times, serif',
//     fontSize: '0.875rem',
//     padding: '8.5px 14px',
//   },
// }));

// const ThinDivider = styled('div')(({ theme }) => ({
//   height: '1px',
//   backgroundColor: '#e0e0e0',
//   margin: '8px 0',
// }));

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   fontWeight: 'bold',
//   backgroundColor: '#f5f5f5',
//   fontFamily: '"Times New Roman", Times, serif',
// }));

// function TabPanel({ children, value, index, ...other }) {
//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`simple-tabpanel-${index}`}
//       aria-labelledby={`simple-tab-${index}`}
//       {...other}
//     >
//       {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
//     </div>
//   );
// }

// // ========== TAB 1: REGISTER HANDOVER ==========
// function RegisterHandoverTab({ onHandoverSaved }) {
//   const decodedUser = useDecodedUser();
//   const [formData, setFormData] = useState({
//     agreement_id: "",
//     handover_date: new Date().toISOString().split("T")[0],
//     handedover_by: "",
//     handedover_to: "",
//     notes: "",
//     signed_document_path: "",
//     description: "",
//     park_id: "",
//   });
//   const [selectedAgreement, setSelectedAgreement] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isUserLoading, setIsUserLoading] = useState(true);
//   const [agreementsList, setAgreementsList] = useState([]);

//   useEffect(() => {
//     if (decodedUser) {
//       setIsUserLoading(false);
//       setFormData(prev => ({
//         ...prev,
//         handedover_by: decodedUser.full_name || "",
//         park_id: decodedUser.park_id || ""
//       }));
      
//       const fetchAgreements = async () => {
//         try {
//           const params = { park_id: decodedUser.park_id, type: 'Land Leased' };
          
//           console.log("Fetching agreements with params:", params);
          
//           const agreData = await GetDataFromApiWithParams(`parks/getAgreementByType`, params);
          
//           const agreDataArray = Array.isArray(agreData) ? agreData : 
//                       (agreData && agreData.data && Array.isArray(agreData.data)) ? agreData.data :
//                       (agreData && typeof agreData === 'object') ? [agreData] : [];
          
//           console.log("Processed agreements list:", agreDataArray);
//           setAgreementsList(agreDataArray);
          
//         } catch (error) {
//           console.error("Error fetching agreements:", error);
//           setAgreementsList([]);
//         }
//       };
      
//       fetchAgreements();
//     }
//   }, [decodedUser]);

//   const handleChange = (event) => {
//     const { name, value } = event.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       setFormData(prev => ({ ...prev, signed_document_path: file }));
//     }
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();
    
//     if (!selectedAgreement?.id) {
//       toast.error("Please select an agreement", { position: "top-right" });
//       return;
//     }
  
//     if (!formData.handedover_to.trim()) {
//       toast.error("Please enter who the handover is being given to", { position: "top-right" });
//       return;
//     }
  
//     setIsLoading(true);
    
//     try {
//       const formDataToSend = new FormData();
      
//       formDataToSend.append("agreement_id", selectedAgreement.id);
//       formDataToSend.append("handover_date", formData.handover_date);
//       formDataToSend.append("handedover_by", decodedUser?.full_name || "");
//       formDataToSend.append("handedover_to", formData.handedover_to);
//       formDataToSend.append("notes", formData.notes || "");
//       formDataToSend.append("description", formData.description || "");
//       formDataToSend.append("park_id", decodedUser?.park_id || "");
      
//       if (formData.signed_document_path) {
//         formDataToSend.append("file", formData.signed_document_path);
//       }
      
//       const result = await ExecutePostWithParams(`parks/handover`, formDataToSend, true);
      
//       if (result) {
//         // Extract the ID properly - result is an array with id property
//         const handoverId = result[0]?.id || result.id || result;
        
//         setFormData({
//           agreement_id: "",
//           handover_date: new Date().toISOString().split("T")[0],
//           handedover_by: decodedUser?.full_name || "",
//           handedover_to: "",
//           notes: "",
//           signed_document_path: "",
//           description: "",
//           park_id: decodedUser?.park_id || "",
//         });
//         setSelectedAgreement(null);
        
//         const fileInput = document.querySelector('input[type="file"]');
//         if (fileInput) fileInput.value = '';
        
//         if (onHandoverSaved) {
//           onHandoverSaved(handoverId);
//         }
        
//         toast.success("Handover registered successfully!", { position: "top-right" });
//       }
//     } catch (error) {
//       console.error("Error:", error);
//       toast.error("Failed to register handover", { position: "top-right" });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   if (isUserLoading) {
//     return (
//       <Container>
//         <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//           <CircularProgress size={24} />
//           <TimesTypography sx={{ ml: 2 }}>Loading...</TimesTypography>
//         </Box>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="lg">
//       <ToastContainer />
      
//       <FormContainer title="Register Handover Details" onSubmit={handleSubmit}>
//         <Grid container spacing={1.5}>
//           <Grid item xs={12} md={6}>
//             <Grid container spacing={1.5}>
//               <Grid item xs={12}>
//                 <FormControl fullWidth size="small" sx={{ mb: 1 }}>
//                   <InputLabel sx={{ fontFamily: '"Times New Roman", Times, serif', fontSize: '0.8rem' }}>
//                     Select Agreement
//                   </InputLabel>
//                   <Select
//                     value={selectedAgreement ? selectedAgreement.id : ''}
//                     onChange={(e) => {
//                       const selectedId = e.target.value;
//                       const agreement = agreementsList.find(ag => ag.id === selectedId);
//                       setSelectedAgreement(agreement || null);
//                     }}
//                     label="Select Agreement"
//                     sx={{
//                       fontFamily: '"Times New Roman", Times, serif',
//                       fontSize: '0.8rem',
//                       height: '32px',
//                       '& .MuiSelect-select': { padding: '6px 10px' }
//                     }}
//                   >
//                     <MenuItem value="" sx={{ fontFamily: '"Times New Roman", Times, serif', fontSize: '0.8rem' }}>
//                       <em>None</em>
//                     </MenuItem>
//                     {agreementsList.map((agreement) => (
//                       <MenuItem 
//                         key={agreement.id} 
//                         value={agreement.id}
//                         sx={{ fontFamily: '"Times New Roman", Times, serif', fontSize: '0.8rem', whiteSpace: 'normal', py: 0.5 }}
//                       >
//                         {agreement?.name || agreement?.agreement_no || agreement?.id}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//                 <ThinDivider />
//               </Grid>
              
//               <Grid item xs={12}>
//                 <TimesTextField
//                   label="Handover Date"
//                   type="date"
//                   name="handover_date"
//                   fullWidth
//                   size="small"
//                   InputLabelProps={{ shrink: true }}
//                   value={formData.handover_date}
//                   onChange={handleChange}
//                   required
//                   disabled={isLoading}
//                 />
//               </Grid>
              
//               <Grid item xs={12}>
//                 <TimesTextField
//                   label="Handed Over By"
//                   name="handedover_by"
//                   fullWidth
//                   size="small"
//                   value={formData.handedover_by}
//                   disabled
//                 />
//               </Grid>
              
//               <Grid item xs={12}>
//                 <TimesTextField
//                   label="Handed Over To"
//                   name="handedover_to"
//                   fullWidth
//                   size="small"
//                   value={formData.handedover_to}
//                   onChange={handleChange}
//                   required
//                   disabled={isLoading}
//                 />
//               </Grid>
              
//               <Grid item xs={12}>
//                 <TimesTextField
//                   label="Notes"
//                   name="notes"
//                   fullWidth
//                   size="small"
//                   value={formData.notes}
//                   onChange={handleChange}
//                   disabled={isLoading}
//                   multiline
//                   rows={1}
//                 />
//               </Grid>
              
//               <Grid item xs={12}>
//                 <TimesTypography variant="subtitle2" sx={{ mb: 0.5, fontWeight: 400 }}>
//                   Signed Document
//                 </TimesTypography>
//                 <TimesInput
//                   type="file"
//                   fullWidth
//                   size="small"
//                   disabled={isLoading}
//                   inputProps={{ accept: "application/pdf,image/*" }}
//                   onChange={handleFileChange}
//                 />
//                 <TimesTypography variant="caption" color="textSecondary" sx={{ mt: 0.5, display: 'block' }}>
//                   Accepts PDF or image files
//                 </TimesTypography>
//                 <ThinDivider />
//               </Grid>
              
//               <Grid item xs={12}>
//                 <TimesTextField
//                   label="Description"
//                   name="description"
//                   fullWidth
//                   size="small"
//                   value={formData.description}
//                   onChange={handleChange}
//                   disabled={isLoading}
//                   multiline
//                   rows={2}
//                 />
//               </Grid>
//             </Grid>
//           </Grid>
          
//           <Grid item xs={12} md={6}>
//             <Box sx={{ height: "100%", border: '1px solid #e0e0e0', borderRadius: 0.5, p: 1.5, backgroundColor: '#fafafa' }}>
//               <TimesTypography variant="h6" align="center" gutterBottom sx={{ fontSize: '0.9375rem', fontWeight: 300, mb: 1.5 }}>
//                 Agreement Details
//               </TimesTypography>
              
//               {selectedAgreement ? (
//                 <Box sx={{ height: '450px', overflow: 'auto' }}>
//                   <IPDCFormattedJsonToDisplay data={selectedAgreement} height="450px" />
//                 </Box>
//               ) : (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '450px', border: '1px dashed #bdbdbd', borderRadius: 0.5, backgroundColor: '#ffffff' }}>
//                   <TimesTypography color="textSecondary" sx={{ fontSize: '0.8125rem', fontStyle: 'italic' }}>
//                     Select an agreement *
//                   </TimesTypography>
//                 </Box>
//               )}
//             </Box>
//           </Grid>
          
//           <Grid item xs={12}>
//             <Button 
//               type="submit"
//               variant="contained" 
//               color="primary"
//               fullWidth
//               disabled={isLoading}
//               startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : <Save />}
//             >
//               {isLoading ? "Saving..." : "Register Handover"}
//             </Button>
//           </Grid>
//         </Grid>
//       </FormContainer>
//     </Container>
//   );
// }

// // ========== TAB 2: IPDC HANDOVER FORM ==========
// function IPDCHandoverFormTab({ handoverId, onSave, parkName }) {
//   const [formData, setFormData] = useState({
//     date: new Date().toISOString().split("T")[0],
//     industrialPark: parkName || 'Loading...',
//     lesseeName: '',
//     titleDeedNumber: '',
//     plotLocation: '',
//     coordinates: [
//       { northing: '', easting: '' },
//       { northing: '', easting: '' },
//       { northing: '', easting: '' },
//       { northing: '', easting: '' },
//       { northing: '', easting: '' },
//       { northing: '', easting: '' },
//       { northing: '', easting: '' },
//       { northing: '', easting: '' }
//     ],
//     area: '',
//     zoning: '',
//     manufacturingFor: '',
//     undergroundLines: {
//       stormDrainage: '',
//       sewageDrainage: '',
//       wasteDrainage: '',
//       powerSupply: '',
//       telecomLine: ''
//     },
//     waterSupplyLine: '',
//     entranceGate: '',
//     benchMark: '',
//     rmu: '',
//     walkway: '',
//     landscape: '',
//     lessorRepresentative: {
//       name: '',
//       signature: '',
//       date: ''
//     },
//     lesseeRepresentative: {
//       name: '',
//       signature: '',
//       date: ''
//     },
//     witnesses: [
//       { name: '', signature: '', date: '' },
//       { name: '', signature: '', date: '' },
//       { name: '', signature: '', date: '' }
//     ]
//   });

//   const [isSaving, setIsSaving] = useState(false);

//   // Update park name when it changes
//   useEffect(() => {
//     if (parkName) {
//       setFormData(prev => ({ ...prev, industrialPark: parkName }));
//     }
//   }, [parkName]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleCoordinateChange = (index, field, value) => {
//     const updatedCoordinates = [...formData.coordinates];
//     updatedCoordinates[index][field] = value;
//     setFormData(prev => ({ ...prev, coordinates: updatedCoordinates }));
//   };

//   const handleUndergroundLineChange = (field, value) => {
//     setFormData(prev => ({
//       ...prev,
//       undergroundLines: { ...prev.undergroundLines, [field]: value }
//     }));
//   };

//   const handleRepresentativeChange = (type, field, value) => {
//     setFormData(prev => ({
//       ...prev,
//       [type]: { ...prev[type], [field]: value }
//     }));
//   };

//   const handleWitnessChange = (index, field, value) => {
//     const updatedWitnesses = [...formData.witnesses];
//     updatedWitnesses[index][field] = value;
//     setFormData(prev => ({ ...prev, witnesses: updatedWitnesses }));
//   };

//   const handlePrint = () => window.print();

// // In IPDCHandoverFormTab component
// const handleSubmit = async (e) => {
//   e.preventDefault();
  
//   if (!handoverId) {
//     toast.error("Please save handover details first", { position: "top-right" });
//     return;
//   }
  
//   setIsSaving(true);
  
//   try {
//     const submitData = {
//       handover_id: handoverId, // This will go into the 'id' column
//       date: formData.date,
//       lesseeName: formData.lesseeName,
//       titleDeedNumber: formData.titleDeedNumber,
//       plotLocation: formData.plotLocation,
//       area: formData.area,
//       zoning: formData.zoning,
//       manufacturingFor: formData.manufacturingFor,
//       coordinates: formData.coordinates,
//       undergroundLines: formData.undergroundLines,
//       waterSupplyLine: formData.waterSupplyLine,
//       entranceGate: formData.entranceGate,
//       benchMark: formData.benchMark,
//       rmu: formData.rmu,
//       walkway: formData.walkway,
//       landscape: formData.landscape,
//       lessorRepresentative: formData.lessorRepresentative,
//       lesseeRepresentative: formData.lesseeRepresentative,
//       witnesses: formData.witnesses
//     };
    
//     const result = await ExecutePostWithParams(`parks/land-handover-form`, submitData);
    
//     toast.success("IPDC Handover form saved successfully!", { position: "top-right" });
    
//     if (onSave) {
//       onSave();
//     }
//   } catch (error) {
//     console.error("Error saving IPDC handover:", error);
//     toast.error("Failed to save IPDC handover: " + (error.message || "Unknown error"), { position: "top-right" });
//   } finally {
//     setIsSaving(false);
//   }
// };

//   return (
//     <Box sx={{ p: 3, maxWidth: 1200, margin: '0 auto' }}>
//       <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2, gap: 2 }}>
//         <Button variant="outlined" startIcon={<Print />} onClick={handlePrint}>Print Form</Button>
//         <Button variant="outlined" startIcon={<Download />}>Export PDF</Button>
//       </Box>

//       {!handoverId && (
//         <Paper sx={{ p: 2, mb: 3, bgcolor: '#fff3e0' }}>
//           <Typography sx={{ color: '#ed6c02' }}>Please register handover details in Tab 1 first to enable saving this form.</Typography>
//         </Paper>
//       )}

//       <form onSubmit={handleSubmit}>
//         {/* Section 1: Basic Information */}
//         <Card sx={{ mb: 3 }}>
//           <CardContent>
//             <Typography variant="h6" sx={{ mb: 2, color: '#1a237e', borderBottom: '2px solid #1a237e' }}>
//               <Home sx={{ mr: 1 }} /> Basic Information
//             </Typography>
//             <Grid container spacing={3}>
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Date of Handover"
//                   name="date"
//                   type="date"
//                   value={formData.date}
//                   onChange={handleInputChange}
//                   InputLabelProps={{ shrink: true }}
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Industrial Park"
//                   name="industrialPark"
//                   value={formData.industrialPark}
//                   InputProps={{ readOnly: true }}
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Lessee (Tenant) Name"
//                   name="lesseeName"
//                   value={formData.lesseeName}
//                   onChange={handleInputChange}
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Title Deed Number"
//                   name="titleDeedNumber"
//                   value={formData.titleDeedNumber}
//                   onChange={handleInputChange}
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Location of Plot (Block)"
//                   name="plotLocation"
//                   value={formData.plotLocation}
//                   onChange={handleInputChange}
//                 />
//               </Grid>
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Area of Plot"
//                   name="area"
//                   value={formData.area}
//                   onChange={handleInputChange}
//                   placeholder="sq. meters"
//                 />
//               </Grid>
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Zoning"
//                   name="zoning"
//                   value={formData.zoning}
//                   onChange={handleInputChange}
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="For Manufacturing of"
//                   name="manufacturingFor"
//                   value={formData.manufacturingFor}
//                   onChange={handleInputChange}
//                 />
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>

//         {/* Section 2: Coordinates */}
//         <Card sx={{ mb: 3 }}>
//           <CardContent>
//             <Typography variant="h6" sx={{ mb: 2, color: '#1a237e', borderBottom: '2px solid #1a237e' }}>
//               <LocationOn sx={{ mr: 1 }} /> Coordinates of Plot
//             </Typography>
//             <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 250 }}>
//               <Table size="small" stickyHeader>
//                 <TableHead>
//                   <TableRow sx={{ bgcolor: '#e8eaf6' }}>
//                     <TableCell sx={{ fontWeight: 'bold' }}>Point</TableCell>
//                     <TableCell sx={{ fontWeight: 'bold' }}>Northing</TableCell>
//                     <TableCell sx={{ fontWeight: 'bold' }}>Easting</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {formData.coordinates.map((coord, index) => (
//                     <TableRow key={index}>
//                       <TableCell>{index + 1}</TableCell>
//                       <TableCell sx={{ py: 0.2 }}>
//                         <TextField
//                           fullWidth
//                           size="small"
//                           value={coord.northing}
//                           onChange={(e) => handleCoordinateChange(index, 'northing', e.target.value)}
//                         />
//                       </TableCell>
//                       <TableCell sx={{ py: 0.2 }}>
//                         <TextField
//                           fullWidth
//                           size="small"
//                           value={coord.easting}
//                           onChange={(e) => handleCoordinateChange(index, 'easting', e.target.value)}
//                         />
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           </CardContent>
//         </Card>

//         {/* Section 3: Utilities and Infrastructure */}
//         <Card sx={{ mb: 3 }}>
//           <CardContent>
//             <Typography variant="h6" sx={{ mb: 2, color: '#1a237e', borderBottom: '2px solid #1a237e' }}>
//               <ElectricalServices sx={{ mr: 1 }} /> Underground Utility Lines and Manholes
//             </Typography>
//             <Grid container spacing={1.5}>
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Branch Storm Drainage Line with Rectangular Concrete Cover Manhole"
//                   value={formData.undergroundLines.stormDrainage}
//                   onChange={(e) => handleUndergroundLineChange('stormDrainage', e.target.value)}
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Branch Sewage Drainage Line with Circular Concrete Cover Manhole"
//                   value={formData.undergroundLines.sewageDrainage}
//                   onChange={(e) => handleUndergroundLineChange('sewageDrainage', e.target.value)}
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Branch Waste Drainage with Circular Concrete Cover Manhole"
//                   value={formData.undergroundLines.wasteDrainage}
//                   onChange={(e) => handleUndergroundLineChange('wasteDrainage', e.target.value)}
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Power Supply Lines with Circular Steel Cover Manhole"
//                   value={formData.undergroundLines.powerSupply}
//                   onChange={(e) => handleUndergroundLineChange('powerSupply', e.target.value)}
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Telecom Line with Circular Steel Cover Manhole"
//                   value={formData.undergroundLines.telecomLine}
//                   onChange={(e) => handleUndergroundLineChange('telecomLine', e.target.value)}
//                 />
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>

//         {/* Section 4: Additional Infrastructure */}
//         <Card sx={{ mb: 3 }}>
//           <CardContent>
//             <Typography variant="h6" sx={{ mb: 2, color: '#1a237e', borderBottom: '2px solid #1a237e' }}>
//               Additional Infrastructure
//             </Typography>
//             <Grid container spacing={1.5}>
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Water Supply Line"
//                   value={formData.waterSupplyLine}
//                   onChange={(e) => setFormData({...formData, waterSupplyLine: e.target.value})}
//                 />
//               </Grid>
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Location of Entrance Gate"
//                   value={formData.entranceGate}
//                   onChange={(e) => setFormData({...formData, entranceGate: e.target.value})}
//                 />
//               </Grid>
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Bench Mark"
//                   value={formData.benchMark}
//                   onChange={(e) => setFormData({...formData, benchMark: e.target.value})}
//                 />
//               </Grid>
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="RMU"
//                   value={formData.rmu}
//                   onChange={(e) => setFormData({...formData, rmu: e.target.value})}
//                 />
//               </Grid>
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Walkway"
//                   value={formData.walkway}
//                   onChange={(e) => setFormData({...formData, walkway: e.target.value})}
//                 />
//               </Grid>
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Landscape of the Plot"
//                   value={formData.landscape}
//                   onChange={(e) => setFormData({...formData, landscape: e.target.value})}
//                 />
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>

//         {/* Section 5: Signatures */}
//         <Card sx={{ mb: 3 }}>
//           <CardContent>
//             <Typography variant="h6" sx={{ mb: 2, color: '#1a237e', borderBottom: '2px solid #1a237e' }}>
//               <Handshake sx={{ mr: 1 }} /> Representatives Signatures
//             </Typography>
//             <Grid container spacing={1.5}>
//               <Grid item xs={12} md={6}>
//                 <Paper variant="outlined" sx={{ p: 1.5, bgcolor: '#fafafa' }}>
//                   <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1.5 }}>
//                     Representative of Lessor (IPDC)
//                   </Typography>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Name"
//                     value={formData.lessorRepresentative.name}
//                     onChange={(e) => handleRepresentativeChange('lessorRepresentative', 'name', e.target.value)}
//                     sx={{ mb: 1.5 }}
//                   />
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Signature"
//                     value={formData.lessorRepresentative.signature}
//                     onChange={(e) => handleRepresentativeChange('lessorRepresentative', 'signature', e.target.value)}
//                     sx={{ mb: 1.5 }}
//                   />
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Date"
//                     type="date"
//                     value={formData.lessorRepresentative.date}
//                     onChange={(e) => handleRepresentativeChange('lessorRepresentative', 'date', e.target.value)}
//                     InputLabelProps={{ shrink: true }}
//                   />
//                 </Paper>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Paper variant="outlined" sx={{ p: 1.5, bgcolor: '#fafafa' }}>
//                   <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1.5 }}>
//                     Representative of Lessee (Investor)
//                   </Typography>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Name"
//                     value={formData.lesseeRepresentative.name}
//                     onChange={(e) => handleRepresentativeChange('lesseeRepresentative', 'name', e.target.value)}
//                     sx={{ mb: 1.5 }}
//                   />
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Signature"
//                     value={formData.lesseeRepresentative.signature}
//                     onChange={(e) => handleRepresentativeChange('lesseeRepresentative', 'signature', e.target.value)}
//                     sx={{ mb: 1.5 }}
//                   />
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Date"
//                     type="date"
//                     value={formData.lesseeRepresentative.date}
//                     onChange={(e) => handleRepresentativeChange('lesseeRepresentative', 'date', e.target.value)}
//                     InputLabelProps={{ shrink: true }}
//                   />
//                 </Paper>
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>

//         {/* Section 6: Witnesses */}
//         <Card sx={{ mb: 3 }}>
//           <CardContent>
//             <Typography variant="h6" sx={{ mb: 2, color: '#1a237e', borderBottom: '2px solid #1a237e' }}>
//               <Person sx={{ mr: 1 }} /> Witnesses
//             </Typography>
//             <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 200 }}>
//               <Table size="small" stickyHeader>
//                 <TableHead>
//                   <TableRow sx={{ bgcolor: '#e8eaf6' }}>
//                     <TableCell sx={{ fontWeight: 'bold' }}>#</TableCell>
//                     <TableCell sx={{ fontWeight: 'bold' }}>Name</TableCell>
//                     <TableCell sx={{ fontWeight: 'bold' }}>Signature</TableCell>
//                     <TableCell sx={{ fontWeight: 'bold' }}>Date</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {formData.witnesses.map((witness, index) => (
//                     <TableRow key={index}>
//                       <TableCell>{index + 1}</TableCell>
//                       <TableCell sx={{ py: 0.2 }}>
//                         <TextField
//                           fullWidth
//                           size="small"
//                           value={witness.name}
//                           onChange={(e) => handleWitnessChange(index, 'name', e.target.value)}
//                         />
//                       </TableCell>
//                       <TableCell sx={{ py: 0.2 }}>
//                         <TextField
//                           fullWidth
//                           size="small"
//                           value={witness.signature}
//                           onChange={(e) => handleWitnessChange(index, 'signature', e.target.value)}
//                         />
//                       </TableCell>
//                       <TableCell sx={{ py: 0.2 }}>
//                         <TextField
//                           fullWidth
//                           size="small"
//                           type="date"
//                           value={witness.date}
//                           onChange={(e) => handleWitnessChange(index, 'date', e.target.value)}
//                           InputLabelProps={{ shrink: true }}
//                         />
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           </CardContent>
//         </Card>

//         {/* Footer Notes */}
//         <Paper elevation={1} sx={{ p: 2, mb: 3, bgcolor: '#fff9c4' }}>
//           <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
//             <Chip label="Note" size="small" color="warning" />
//             This Handover form is prepared in four copies:
//             <Chip label="Company" size="small" variant="outlined" />
//             <Chip label="IPDC File" size="small" variant="outlined" />
//             <Chip label="Operations Management" size="small" variant="outlined" />
//             <Chip label="IP Branch Office" size="small" variant="outlined" />
//           </Typography>
//           <Typography variant="body2" sx={{ mt: 1, fontStyle: 'italic' }}>
//             This certificate is certified having of authorized Lessee and IPDC Stamp is provided
//           </Typography>
//         </Paper>

//         {/* Submit Button */}
//         <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 3 }}>
//           <Button
//             type="submit"
//             variant="contained"
//             size="large"
//             disabled={isSaving || !handoverId}
//             startIcon={isSaving ? <CircularProgress size={20} color="inherit" /> : <Save />}
//             sx={{ bgcolor: '#1a237e', '&:hover': { bgcolor: '#283593' } }}
//           >
//             {isSaving ? "Saving..." : "Submit Handover Form"}
//           </Button>
//         </Box>
        
//         {!handoverId && (
//           <Typography sx={{ color: 'error.main', fontSize: '0.875rem', textAlign: 'center' }}>
//             Please register handover details in Tab 1 first to enable saving this form
//           </Typography>
//         )}
//       </form>
//     </Box>
//   );
// }

// // ========== MAIN COMPONENT WITH TABS ==========
// export default function InspectionManagement() {
//   const [tabValue, setTabValue] = useState(0);
//   const [currentHandoverId, setCurrentHandoverId] = useState(null);
//   const decodedUser = useDecodedUser();
//   const [parkName, setParkName] = useState('');

//   // Fetch park name when component mounts
//   useEffect(() => {
//     const fetchParkName = async () => {
//       if (decodedUser?.park_id) {
//         try {
//           const parkData = await GetDataFromApiWithParams(`parks/${decodedUser.park_id}`, {});
//           if (parkData && parkData.name) {
//             setParkName(parkData.name);
//           } else if (parkData && typeof parkData === 'object') {
//             setParkName(parkData.name || parkData.park_name || 'Industrial Park');
//           } else {
//             setParkName('Industrial Park');
//           }
//         } catch (error) {
//           console.error("Error fetching park name:", error);
//           setParkName('Industrial Park');
//         }
//       }
//     };
    
//     fetchParkName();
//   }, [decodedUser]);

//   const handleTabChange = (event, newValue) => setTabValue(newValue);
  
//   const handleHandoverSaved = (handoverId) => {
//     // Ensure handoverId is a string
//     const id = typeof handoverId === 'object' && handoverId.id ? handoverId.id : handoverId;
//     setCurrentHandoverId(id);
//     toast.success("Handover registered successfully!", { position: "top-right" });
//   };

//   const handleFormSaved = () => {
//     toast.success("IPDC Handover form saved successfully!", { position: "top-right" });
//   };

//   return (
//     <Box sx={{ flexGrow: 1 }}>
//       <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
//         <Tabs value={tabValue} onChange={handleTabChange} aria-label="inspection tabs">
//           <Tab icon={<Verified />} label="Register Handover" iconPosition="start" />
//           <Tab icon={<Assignment />} label="Land Handover Form" iconPosition="start" />
//         </Tabs>
//       </Box>

//       <TabPanel value={tabValue} index={0}>
//         <RegisterHandoverTab onHandoverSaved={handleHandoverSaved} />
//       </TabPanel>

//       <TabPanel value={tabValue} index={1}>
//         <IPDCHandoverFormTab 
//           handoverId={currentHandoverId} 
//           onSave={handleFormSaved}
//           parkName={parkName}
//         />
//       </TabPanel>
//     </Box>
//   );
// }
//*************************************************************************************** */
// import React, { useState, useEffect, useRef } from "react";
// import { 
//   Home, List, Logout, Map, Print, Report, Handshake,
//   SettingsAccessibility, CheckCircle, Warning, Error,
//   Description, Save, Assignment, Verified, Person,
//   BusinessCenter, CalendarToday, SquareFoot,
//   LocationOn, ElectricalServices, Edit, Download
// } from "@mui/icons-material";
// import {
//   Box,
//   Paper,
//   Typography,
//   InputLabel,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Chip,
//   IconButton,
//   Button,
//   TextField,
//   MenuItem,
//   Select,
//   FormControl,
//   Divider,
//   Grid,
//   Card,
//   CardContent,
//   Tabs,
//   Tab,
//   AppBar,
//   Toolbar,
//   Container,
//   CircularProgress,
//   Input,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// // Import your custom components
// import FormContainer from "../../../../components/Forms/FormContainer";
// import useDecodedUser from "../../../../services/hooks/useDecodedUser";
// import { ExecutePostWithParams, GetDataFromApiWithParams } from "../../../../services/api/ExecuteApiRequests";
// import { IPDCFormattedJsonToDisplay } from "../../../../components/Controls";

// // Use public folder path for logo (no import needed)
// const IPDCLogo = "/IPDC_LOGO.jpg";
// const EthiopiaLogo = "/et logo.png";

// // ========== STYLED COMPONENTS ==========
// const TimesTextField = styled(TextField)(({ theme }) => ({
//   '& .MuiInputBase-root': {
//     fontFamily: '"Times New Roman", Times, serif',
//     fontSize: '0.875rem',
//     fontWeight: 400,
//   },
//   '& .MuiInputLabel-root': {
//     fontFamily: '"Times New Roman", Times, serif',
//     fontSize: '0.875rem',
//     fontWeight: 400,
//   },
//   '& .MuiOutlinedInput-root': {
//     '& fieldset': { borderWidth: '1px' },
//     '&:hover fieldset': { borderWidth: '1px' },
//     '&.Mui-focused fieldset': { borderWidth: '1px' },
//   },
// }));

// const TimesTypography = styled(Typography)(({ theme }) => ({
//   fontFamily: '"Times New Roman", Times, serif !important',
// }));

// const TimesInput = styled(Input)(({ theme }) => ({
//   '& .MuiInputBase-input': {
//     fontFamily: '"Times New Roman", Times, serif',
//     fontSize: '0.875rem',
//     padding: '8.5px 14px',
//   },
// }));

// const ThinDivider = styled('div')(({ theme }) => ({
//   height: '1px',
//   backgroundColor: '#e0e0e0',
//   margin: '8px 0',
// }));

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   fontWeight: 'bold',
//   backgroundColor: '#f5f5f5',
//   fontFamily: '"Times New Roman", Times, serif',
// }));

// // Print styles
// const PrintStyle = () => (
//   <style type="text/css" media="print">
//     {`
//       @media print {
//         .no-print {
//           display: none !important;
//         }
//         .print-only {
//           display: block !important;
//         }
//         body {
//           margin: 0;
//           padding: 0;
//         }
//         .MuiPaper-root {
//           box-shadow: none !important;
//           border: none !important;
//         }
//         button {
//           display: none !important;
//         }
//         .MuiButton-root {
//           display: none !important;
//         }
//         .MuiIconButton-root {
//           display: none !important;
//         }
//         .MuiTabs-root {
//           display: none !important;
//         }
//         .MuiTab-root {
//           display: none !important;
//         }
//         .MuiAppBar-root {
//           display: none !important;
//         }
//         header {
//           display: none !important;
//         }
//         nav {
//           display: none !important;
//         }
//         .sidebar {
//           display: none !important;
//         }
//         .MuiDrawer-root {
//           display: none !important;
//         }
//         .MuiToolbar-root {
//           display: none !important;
//         }
//         @page {
//           size: A4;
//           margin: 1.5cm;
//         }
//       }
//     `}
//   </style>
// );

// function TabPanel({ children, value, index, ...other }) {
//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`simple-tabpanel-${index}`}
//       aria-labelledby={`simple-tab-${index}`}
//       {...other}
//     >
//       {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
//     </div>
//   );
// }

// // ========== TAB 1: REGISTER HANDOVER ==========
// function RegisterHandoverTab({ onHandoverSaved }) {
//   const decodedUser = useDecodedUser();
//   const [formData, setFormData] = useState({
//     agreement_id: "",
//     handover_date: new Date().toISOString().split("T")[0],
//     handedover_by: "",
//     handedover_to: "",
//     notes: "",
//     signed_document_path: "",
//     description: "",
//     park_id: "",
//   });
//   const [selectedAgreement, setSelectedAgreement] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isUserLoading, setIsUserLoading] = useState(true);
//   const [agreementsList, setAgreementsList] = useState([]);

//   useEffect(() => {
//     if (decodedUser) {
//       setIsUserLoading(false);
//       setFormData(prev => ({
//         ...prev,
//         handedover_by: decodedUser.full_name || "",
//         park_id: decodedUser.park_id || ""
//       }));
      
//       const fetchAgreements = async () => {
//         try {
//           const params = { park_id: decodedUser.park_id, type: 'Land Leased' };
//           const agreData = await GetDataFromApiWithParams(`parks/getAgreementByType`, params);
//           const agreDataArray = Array.isArray(agreData) ? agreData : 
//                       (agreData && agreData.data && Array.isArray(agreData.data)) ? agreData.data :
//                       (agreData && typeof agreData === 'object') ? [agreData] : [];
//           setAgreementsList(agreDataArray);
//         } catch (error) {
//           console.error("Error fetching agreements:", error);
//           setAgreementsList([]);
//         }
//       };
//       fetchAgreements();
//     }
//   }, [decodedUser]);

//   const handleChange = (event) => {
//     const { name, value } = event.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       setFormData(prev => ({ ...prev, signed_document_path: file }));
//     }
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();
    
//     if (!selectedAgreement?.id) {
//       toast.error("Please select an agreement", { position: "top-right" });
//       return;
//     }
  
//     if (!formData.handedover_to.trim()) {
//       toast.error("Please enter who the handover is being given to", { position: "top-right" });
//       return;
//     }
  
//     setIsLoading(true);
    
//     try {
//       const formDataToSend = new FormData();
//       formDataToSend.append("agreement_id", selectedAgreement.id);
//       formDataToSend.append("handover_date", formData.handover_date);
//       formDataToSend.append("handedover_by", decodedUser?.full_name || "");
//       formDataToSend.append("handedover_to", formData.handedover_to);
//       formDataToSend.append("notes", formData.notes || "");
//       formDataToSend.append("description", formData.description || "");
//       formDataToSend.append("park_id", decodedUser?.park_id || "");
      
//       if (formData.signed_document_path) {
//         formDataToSend.append("file", formData.signed_document_path);
//       }
      
//       const result = await ExecutePostWithParams(`parks/handover`, formDataToSend, true);
      
//       if (result) {
//         const handoverId = result[0]?.id || result.id || result;
//         setFormData({
//           agreement_id: "",
//           handover_date: new Date().toISOString().split("T")[0],
//           handedover_by: decodedUser?.full_name || "",
//           handedover_to: "",
//           notes: "",
//           signed_document_path: "",
//           description: "",
//           park_id: decodedUser?.park_id || "",
//         });
//         setSelectedAgreement(null);
//         const fileInput = document.querySelector('input[type="file"]');
//         if (fileInput) fileInput.value = '';
//         if (onHandoverSaved) onHandoverSaved(handoverId);
//         toast.success("Handover registered successfully!", { position: "top-right" });
//       }
//     } catch (error) {
//       console.error("Error:", error);
//       toast.error("Failed to register handover", { position: "top-right" });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   if (isUserLoading) {
//     return (
//       <Container>
//         <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//           <CircularProgress size={24} />
//           <TimesTypography sx={{ ml: 2 }}>Loading...</TimesTypography>
//         </Box>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="lg">
//       <ToastContainer />
//       <FormContainer title="Register Handover Details" onSubmit={handleSubmit}>
//         <Grid container spacing={1.5}>
//           <Grid item xs={12} md={6}>
//             <Grid container spacing={1.5}>
//               <Grid item xs={12}>
//                 <FormControl fullWidth size="small" sx={{ mb: 1 }}>
//                   <InputLabel sx={{ fontFamily: '"Times New Roman", Times, serif', fontSize: '0.8rem' }}>
//                     Select Agreement
//                   </InputLabel>
//                   <Select
//                     value={selectedAgreement ? selectedAgreement.id : ''}
//                     onChange={(e) => {
//                       const selectedId = e.target.value;
//                       const agreement = agreementsList.find(ag => ag.id === selectedId);
//                       setSelectedAgreement(agreement || null);
//                     }}
//                     label="Select Agreement"
//                     sx={{
//                       fontFamily: '"Times New Roman", Times, serif',
//                       fontSize: '0.8rem',
//                       height: '32px',
//                       '& .MuiSelect-select': { padding: '6px 10px' }
//                     }}
//                   >
//                     <MenuItem value="" sx={{ fontFamily: '"Times New Roman", Times, serif', fontSize: '0.8rem' }}>
//                       <em>None</em>
//                     </MenuItem>
//                     {agreementsList.map((agreement) => (
//                       <MenuItem 
//                         key={agreement.id} 
//                         value={agreement.id}
//                         sx={{ fontFamily: '"Times New Roman", Times, serif', fontSize: '0.8rem', whiteSpace: 'normal', py: 0.5 }}
//                       >
//                         {agreement?.name || agreement?.agreement_no || agreement?.id}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//                 <ThinDivider />
//               </Grid>
              
//               <Grid item xs={12}>
//                 <TimesTextField
//                   label="Handover Date"
//                   type="date"
//                   name="handover_date"
//                   fullWidth
//                   size="small"
//                   InputLabelProps={{ shrink: true }}
//                   value={formData.handover_date}
//                   onChange={handleChange}
//                   required
//                   disabled={isLoading}
//                 />
//               </Grid>
              
//               <Grid item xs={12}>
//                 <TimesTextField
//                   label="Handed Over By"
//                   name="handedover_by"
//                   fullWidth
//                   size="small"
//                   value={formData.handedover_by}
//                   disabled
//                 />
//               </Grid>
              
//               <Grid item xs={12}>
//                 <TimesTextField
//                   label="Handed Over To"
//                   name="handedover_to"
//                   fullWidth
//                   size="small"
//                   value={formData.handedover_to}
//                   onChange={handleChange}
//                   required
//                   disabled={isLoading}
//                 />
//               </Grid>
              
//               <Grid item xs={12}>
//                 <TimesTextField
//                   label="Notes"
//                   name="notes"
//                   fullWidth
//                   size="small"
//                   value={formData.notes}
//                   onChange={handleChange}
//                   disabled={isLoading}
//                   multiline
//                   rows={1}
//                 />
//               </Grid>
              
//               <Grid item xs={12}>
//                 <TimesTypography variant="subtitle2" sx={{ mb: 0.5, fontWeight: 400 }}>
//                   Signed Document
//                 </TimesTypography>
//                 <TimesInput
//                   type="file"
//                   fullWidth
//                   size="small"
//                   disabled={isLoading}
//                   inputProps={{ accept: "application/pdf,image/*" }}
//                   onChange={handleFileChange}
//                 />
//                 <TimesTypography variant="caption" color="textSecondary" sx={{ mt: 0.5, display: 'block' }}>
//                   Accepts PDF or image files
//                 </TimesTypography>
//                 <ThinDivider />
//               </Grid>
              
//               <Grid item xs={12}>
//                 <TimesTextField
//                   label="Description"
//                   name="description"
//                   fullWidth
//                   size="small"
//                   value={formData.description}
//                   onChange={handleChange}
//                   disabled={isLoading}
//                   multiline
//                   rows={2}
//                 />
//               </Grid>
//             </Grid>
//           </Grid>
          
//           <Grid item xs={12} md={6}>
//             <Box sx={{ height: "100%", border: '1px solid #e0e0e0', borderRadius: 0.5, p: 1.5, backgroundColor: '#fafafa' }}>
//               <TimesTypography variant="h6" align="center" gutterBottom sx={{ fontSize: '0.9375rem', fontWeight: 300, mb: 1.5 }}>
//                 Agreement Details
//               </TimesTypography>
//               {selectedAgreement ? (
//                 <Box sx={{ height: '450px', overflow: 'auto' }}>
//                   <IPDCFormattedJsonToDisplay data={selectedAgreement} height="450px" />
//                 </Box>
//               ) : (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '450px', border: '1px dashed #bdbdbd', borderRadius: 0.5, backgroundColor: '#ffffff' }}>
//                   <TimesTypography color="textSecondary" sx={{ fontSize: '0.8125rem', fontStyle: 'italic' }}>
//                     Select an agreement *
//                   </TimesTypography>
//                 </Box>
//               )}
//             </Box>
//           </Grid>
          
//           <Grid item xs={12}>
//             <Button 
//               type="submit"
//               variant="contained" 
//               color="primary"
//               fullWidth
//               disabled={isLoading}
//               startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : <Save />}
//               className="no-print"
//             >
//               {isLoading ? "Saving..." : "Register Handover"}
//             </Button>
//           </Grid>
//         </Grid>
//       </FormContainer>
//     </Container>
//   );
// }

// // ========== TAB 2: IPDC HANDOVER FORM (PRINTABLE VERSION) ==========
// function IPDCHandoverFormTab({ handoverId, onSave, parkName, initialData }) {
//   const [formData, setFormData] = useState({
//     id: '',
//     date: new Date().toISOString().split("T")[0],
//     industrialPark: parkName || 'Loading...',
//     lesseeName: '',
//     titleDeedNumber: '',
//     plotLocation: '',
//     coordinates: [
//       { northing: '', easting: '' },
//       { northing: '', easting: '' },
//       { northing: '', easting: '' },
//       { northing: '', easting: '' },
//       { northing: '', easting: '' },
//       { northing: '', easting: '' },
//       { northing: '', easting: '' },
//       { northing: '', easting: '' }
//     ],
//     area: '',
//     zoning: '',
//     manufacturingFor: '',
//     undergroundLines: {
//       stormDrainage: '',
//       sewageDrainage: '',
//       wasteDrainage: '',
//       powerSupply: '',
//       telecomLine: ''
//     },
//     waterSupplyLine: '',
//     entranceGate: '',
//     benchMark: '',
//     rmu: '',
//     walkway: '',
//     landscape: '',
//     lessorRepresentative: {
//       name: '',
//       signature: '',
//       date: ''
//     },
//     lesseeRepresentative: {
//       name: '',
//       signature: '',
//       date: ''
//     },
//     witnesses: [
//       { name: '', signature: '', date: '' },
//       { name: '', signature: '', date: '' },
//       { name: '', signature: '', date: '' }
//     ]
//   });

//   const [isSaving, setIsSaving] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const printRef = useRef();

//   // Load existing data if editing
//   useEffect(() => {
//     if (initialData) {
//       setFormData(prev => ({
//         ...prev,
//         ...initialData,
//         industrialPark: parkName || initialData.industrialPark || 'Industrial Park'
//       }));
//     }
//   }, [initialData, parkName]);

//   // Fetch existing form data if handoverId is provided
//   useEffect(() => {
//     const fetchFormData = async () => {
//       if (handoverId && !initialData) {
//         setIsLoading(true);
//         try {
//           const response = await GetDataFromApiWithParams(`parks/land-handover-form/${handoverId}`, {});
//           if (response && response.data) {
//             setFormData(prev => ({
//               ...prev,
//               ...response.data,
//               industrialPark: parkName || response.data.industrialPark || 'Industrial Park'
//             }));
//           }
//         } catch (error) {
//           console.error("Error fetching form data:", error);
//         } finally {
//           setIsLoading(false);
//         }
//       }
//     };
//     fetchFormData();
//   }, [handoverId, parkName, initialData]);

//   // Update park name when it changes
//   useEffect(() => {
//     if (parkName) {
//       setFormData(prev => ({ ...prev, industrialPark: parkName }));
//     }
//   }, [parkName]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleCoordinateChange = (index, field, value) => {
//     const updatedCoordinates = [...formData.coordinates];
//     updatedCoordinates[index][field] = value;
//     setFormData(prev => ({ ...prev, coordinates: updatedCoordinates }));
//   };

//   const handleUndergroundLineChange = (field, value) => {
//     setFormData(prev => ({
//       ...prev,
//       undergroundLines: { ...prev.undergroundLines, [field]: value }
//     }));
//   };

//   const handleRepresentativeChange = (type, field, value) => {
//     setFormData(prev => ({
//       ...prev,
//       [type]: { ...prev[type], [field]: value }
//     }));
//   };

//   const handleWitnessChange = (index, field, value) => {
//     const updatedWitnesses = [...formData.witnesses];
//     updatedWitnesses[index][field] = value;
//     setFormData(prev => ({ ...prev, witnesses: updatedWitnesses }));
//   };

//   const handlePrint = () => {
//     window.print();
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!handoverId) {
//       toast.error("Please save handover details first", { position: "top-right" });
//       return;
//     }
    
//     setIsSaving(true);
//     try {
//       const submitData = {
//         handover_id: handoverId,
//         date: formData.date,
//         lesseeName: formData.lesseeName,
//         titleDeedNumber: formData.titleDeedNumber,
//         plotLocation: formData.plotLocation,
//         area: formData.area,
//         zoning: formData.zoning,
//         manufacturingFor: formData.manufacturingFor,
//         coordinates: formData.coordinates,
//         undergroundLines: formData.undergroundLines,
//         waterSupplyLine: formData.waterSupplyLine,
//         entranceGate: formData.entranceGate,
//         benchMark: formData.benchMark,
//         rmu: formData.rmu,
//         walkway: formData.walkway,
//         landscape: formData.landscape,
//         lessorRepresentative: formData.lessorRepresentative,
//         lesseeRepresentative: formData.lesseeRepresentative,
//         witnesses: formData.witnesses
//       };
      
//       await ExecutePostWithParams(`parks/land-handover-form`, submitData);
//       toast.success("IPDC Handover form saved successfully!", { position: "top-right" });
//       if (onSave) onSave();
//     } catch (error) {
//       console.error("Error saving IPDC handover:", error);
//       toast.error("Failed to save IPDC handover: " + (error.message || "Unknown error"), { position: "top-right" });
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   const FormHeader = () => (
//     <Box sx={{ textAlign: 'center', mb: 4, mt: 2 }}>
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2, gap: 3 }}>
//         <img src={EthiopiaLogo} alt="Ethiopia Logo" style={{ height: '70px' }} />
//         <img src={IPDCLogo} alt="IPDC Logo" style={{ height: '70px' }} />
//       </Box>
//       <Box>
//         <Typography variant="h5" sx={{ fontWeight: 'bold', fontFamily: '"Times New Roman", Times, serif' }}>
//           THE FEDERAL DEMOCRATIC REPUBLIC OF ETHIOPIA
//         </Typography>
//         <Typography variant="h6" sx={{ fontWeight: 'bold', fontFamily: '"Times New Roman", Times, serif' }}>
//           INDUSTRIAL PARKS DEVELOPMENT CORPORATION (IPDC)
//         </Typography>
//         <Typography variant="h6" sx={{ fontWeight: 'bold', fontFamily: '"Times New Roman", Times, serif', textDecoration: 'underline', mt: 2 }}>
//           HANDOVER FORM FOR ALLOCATED LAND (PLOT) TO TENANTS
//         </Typography>
//       </Box>
//     </Box>
//   );

//   if (isLoading) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ p: 3, maxWidth: 1200, margin: '0 auto' }}>
//       <PrintStyle />
      
//       {/* Action Buttons - Hidden when printing */}
//       <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2, gap: 2 }} className="no-print">
//         <Button variant="outlined" startIcon={<Print />} onClick={handlePrint}>
//           Print Form
//         </Button>
//         <Button variant="outlined" startIcon={<Download />}>
//           Export PDF
//         </Button>
//         <Button
//           variant="contained"
//           disabled={isSaving || !handoverId}
//           startIcon={isSaving ? <CircularProgress size={20} color="inherit" /> : <Save />}
//           onClick={handleSubmit}
//           sx={{ bgcolor: '#1a237e', '&:hover': { bgcolor: '#283593' } }}
//         >
//           {isSaving ? "Saving..." : "Save Form"}
//         </Button>
//       </Box>

//       <form onSubmit={handleSubmit}>
//         <div ref={printRef}>
//           <FormHeader />

//           {/* Section 1: Basic Information */}
//           <Card sx={{ mb: 3 }}>
//             <CardContent>
//               <Typography variant="h6" sx={{ mb: 2, color: '#1a237e', borderBottom: '2px solid #1a237e' }}>
//                 <Home sx={{ mr: 1 }} /> Basic Information
//               </Typography>
//               <Grid container spacing={3}>
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Date of Handover"
//                     name="date"
//                     type="date"
//                     value={formData.date}
//                     onChange={handleInputChange}
//                     InputLabelProps={{ shrink: true }}
//                     required
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Industrial Park"
//                     name="industrialPark"
//                     value={formData.industrialPark}
//                     InputProps={{ readOnly: true }}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Lessee (Tenant) Name"
//                     name="lesseeName"
//                     value={formData.lesseeName}
//                     onChange={handleInputChange}
//                     required
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Title Deed Number"
//                     name="titleDeedNumber"
//                     value={formData.titleDeedNumber}
//                     onChange={handleInputChange}
//                     required
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={4}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Location of Plot (Block)"
//                     name="plotLocation"
//                     value={formData.plotLocation}
//                     onChange={handleInputChange}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={4}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Area of Plot (sq. meters)"
//                     name="area"
//                     value={formData.area}
//                     onChange={handleInputChange}
//                     placeholder="sq. meters"
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={4}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Zoning"
//                     name="zoning"
//                     value={formData.zoning}
//                     onChange={handleInputChange}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="For Manufacturing of"
//                     name="manufacturingFor"
//                     value={formData.manufacturingFor}
//                     onChange={handleInputChange}
//                   />
//                 </Grid>
//               </Grid>
//             </CardContent>
//           </Card>

//           {/* Section 2: Coordinates */}
//           <Card sx={{ mb: 3 }}>
//             <CardContent>
//               <Typography variant="h6" sx={{ mb: 2, color: '#1a237e', borderBottom: '2px solid #1a237e' }}>
//                 <LocationOn sx={{ mr: 1 }} /> Coordinates of Plot
//               </Typography>
//               <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 250 }}>
//                 <Table size="small" stickyHeader>
//                   <TableHead>
//                     <TableRow sx={{ bgcolor: '#e8eaf6' }}>
//                       <TableCell sx={{ fontWeight: 'bold' }}>Point</TableCell>
//                       <TableCell sx={{ fontWeight: 'bold' }}>Northing</TableCell>
//                       <TableCell sx={{ fontWeight: 'bold' }}>Easting</TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {formData.coordinates.map((coord, index) => (
//                       <TableRow key={index}>
//                         <TableCell>{index + 1}</TableCell>
//                         <TableCell sx={{ py: 0.2 }}>
//                           <TextField
//                             fullWidth
//                             size="small"
//                             value={coord.northing}
//                             onChange={(e) => handleCoordinateChange(index, 'northing', e.target.value)}
//                           />
//                         </TableCell>
//                         <TableCell sx={{ py: 0.2 }}>
//                           <TextField
//                             fullWidth
//                             size="small"
//                             value={coord.easting}
//                             onChange={(e) => handleCoordinateChange(index, 'easting', e.target.value)}
//                           />
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             </CardContent>
//           </Card>

//           {/* Section 3: Utilities and Infrastructure */}
//           <Card sx={{ mb: 3 }}>
//             <CardContent>
//               <Typography variant="h6" sx={{ mb: 2, color: '#1a237e', borderBottom: '2px solid #1a237e' }}>
//                 <ElectricalServices sx={{ mr: 1 }} /> Underground Utility Lines and Manholes
//               </Typography>
//               <Grid container spacing={1.5}>
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Branch Storm Drainage Line with Rectangular Concrete Cover Manhole"
//                     value={formData.undergroundLines.stormDrainage}
//                     onChange={(e) => handleUndergroundLineChange('stormDrainage', e.target.value)}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Branch Sewage Drainage Line with Circular Concrete Cover Manhole"
//                     value={formData.undergroundLines.sewageDrainage}
//                     onChange={(e) => handleUndergroundLineChange('sewageDrainage', e.target.value)}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Branch Waste Drainage with Circular Concrete Cover Manhole"
//                     value={formData.undergroundLines.wasteDrainage}
//                     onChange={(e) => handleUndergroundLineChange('wasteDrainage', e.target.value)}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Power Supply Lines with Circular Steel Cover Manhole"
//                     value={formData.undergroundLines.powerSupply}
//                     onChange={(e) => handleUndergroundLineChange('powerSupply', e.target.value)}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Telecom Line with Circular Steel Cover Manhole"
//                     value={formData.undergroundLines.telecomLine}
//                     onChange={(e) => handleUndergroundLineChange('telecomLine', e.target.value)}
//                   />
//                 </Grid>
//               </Grid>
//             </CardContent>
//           </Card>

//           {/* Section 4: Additional Infrastructure */}
//           <Card sx={{ mb: 3 }}>
//             <CardContent>
//               <Typography variant="h6" sx={{ mb: 2, color: '#1a237e', borderBottom: '2px solid #1a237e' }}>
//                 Additional Infrastructure
//               </Typography>
//               <Grid container spacing={1.5}>
//                 <Grid item xs={12} md={4}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Water Supply Line"
//                     value={formData.waterSupplyLine}
//                     onChange={(e) => setFormData({...formData, waterSupplyLine: e.target.value})}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={4}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Location of Entrance Gate"
//                     value={formData.entranceGate}
//                     onChange={(e) => setFormData({...formData, entranceGate: e.target.value})}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={4}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Bench Mark"
//                     value={formData.benchMark}
//                     onChange={(e) => setFormData({...formData, benchMark: e.target.value})}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={4}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="RMU"
//                     value={formData.rmu}
//                     onChange={(e) => setFormData({...formData, rmu: e.target.value})}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={4}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Walkway"
//                     value={formData.walkway}
//                     onChange={(e) => setFormData({...formData, walkway: e.target.value})}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={4}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Landscape of the Plot"
//                     value={formData.landscape}
//                     onChange={(e) => setFormData({...formData, landscape: e.target.value})}
//                   />
//                 </Grid>
//               </Grid>
//             </CardContent>
//           </Card>

//           {/* Section 5: Signatures - Read Only */}
//           <Card sx={{ mb: 3 }}>
//             <CardContent>
//               <Typography variant="h6" sx={{ mb: 2, color: '#1a237e', borderBottom: '2px solid #1a237e' }}>
//                 <Handshake sx={{ mr: 1 }} /> Representatives Signatures
//               </Typography>
//               <Grid container spacing={1.5}>
//                 <Grid item xs={12} md={6}>
//                   <Paper variant="outlined" sx={{ p: 1.5, bgcolor: '#fafafa' }}>
//                     <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1.5 }}>
//                       Representative of Lessor (IPDC)
//                     </Typography>
//                     <TextField
//                       fullWidth
//                       size="small"
//                       label="Name"
//                       value={formData.lessorRepresentative.name}
//                       onChange={(e) => handleRepresentativeChange('lessorRepresentative', 'name', e.target.value)}
//                       sx={{ mb: 1.5 }}
//                     />
//                     <TextField
//                       fullWidth
//                       size="small"
//                       label="Signature"
//                       value={formData.lessorRepresentative.signature}
//                       InputProps={{ readOnly: true }}
//                       sx={{ mb: 1.5 }}
//                       className="no-print"
//                     />
//                     <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 1.5, fontStyle: 'italic' }} className="print-only">
//                       (Signature on file)
//                     </Typography>
//                     <TextField
//                       fullWidth
//                       size="small"
//                       label="Date"
//                       type="date"
//                       value={formData.lessorRepresentative.date}
//                       onChange={(e) => handleRepresentativeChange('lessorRepresentative', 'date', e.target.value)}
//                       InputLabelProps={{ shrink: true }}
//                     />
//                   </Paper>
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <Paper variant="outlined" sx={{ p: 1.5, bgcolor: '#fafafa' }}>
//                     <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1.5 }}>
//                       Representative of Lessee (Investor)
//                     </Typography>
//                     <TextField
//                       fullWidth
//                       size="small"
//                       label="Name"
//                       value={formData.lesseeRepresentative.name}
//                       onChange={(e) => handleRepresentativeChange('lesseeRepresentative', 'name', e.target.value)}
//                       sx={{ mb: 1.5 }}
//                     />
//                     <TextField
//                       fullWidth
//                       size="small"
//                       label="Signature"
//                       value={formData.lesseeRepresentative.signature}
//                       InputProps={{ readOnly: true }}
//                       sx={{ mb: 1.5 }}
//                       className="no-print"
//                     />
//                     <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 1.5, fontStyle: 'italic' }} className="print-only">
//                       (Signature on file)
//                     </Typography>
//                     <TextField
//                       fullWidth
//                       size="small"
//                       label="Date"
//                       type="date"
//                       value={formData.lesseeRepresentative.date}
//                       onChange={(e) => handleRepresentativeChange('lesseeRepresentative', 'date', e.target.value)}
//                       InputLabelProps={{ shrink: true }}
//                     />
//                   </Paper>
//                 </Grid>
//               </Grid>
//             </CardContent>
//           </Card>

//           {/* Section 6: Witnesses */}
//           <Card sx={{ mb: 3 }}>
//             <CardContent>
//               <Typography variant="h6" sx={{ mb: 2, color: '#1a237e', borderBottom: '2px solid #1a237e' }}>
//                 <Person sx={{ mr: 1 }} /> Witnesses
//               </Typography>
//               <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 200 }}>
//                 <Table size="small" stickyHeader>
//                   <TableHead>
//                     <TableRow sx={{ bgcolor: '#e8eaf6' }}>
//                       <TableCell sx={{ fontWeight: 'bold' }}>#</TableCell>
//                       <TableCell sx={{ fontWeight: 'bold' }}>Name</TableCell>
//                       <TableCell sx={{ fontWeight: 'bold' }}>Signature</TableCell>
//                       <TableCell sx={{ fontWeight: 'bold' }}>Date</TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {formData.witnesses.map((witness, index) => (
//                       <TableRow key={index}>
//                         <TableCell>{index + 1}</TableCell>
//                         <TableCell sx={{ py: 0.2 }}>
//                           <TextField
//                             fullWidth
//                             size="small"
//                             value={witness.name}
//                             onChange={(e) => handleWitnessChange(index, 'name', e.target.value)}
//                           />
//                         </TableCell>
//                         <TableCell sx={{ py: 0.2 }}>
//                           <TextField
//                             fullWidth
//                             size="small"
//                             value={witness.signature}
//                             InputProps={{ readOnly: true }}
//                             className="no-print"
//                           />
//                           <Typography variant="caption" color="textSecondary" sx={{ display: 'none' }} className="print-only">
//                             (Signature on file)
//                           </Typography>
//                         </TableCell>
//                         <TableCell sx={{ py: 0.2 }}>
//                           <TextField
//                             fullWidth
//                             size="small"
//                             type="date"
//                             value={witness.date}
//                             onChange={(e) => handleWitnessChange(index, 'date', e.target.value)}
//                             InputLabelProps={{ shrink: true }}
//                           />
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             </CardContent>
//           </Card>

//           {/* Footer Notes */}
//           <Paper elevation={1} sx={{ p: 2, mb: 3, bgcolor: '#fff9c4' }}>
//             <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
//               <Chip label="Note" size="small" color="warning" />
//               This Handover form is prepared in four copies:
//               <Chip label="Company" size="small" variant="outlined" />
//               <Chip label="IPDC File" size="small" variant="outlined" />
//               <Chip label="Operations Management" size="small" variant="outlined" />
//               <Chip label="IP Branch Office" size="small" variant="outlined" />
//             </Typography>
//             <Typography variant="body2" sx={{ mt: 1, fontStyle: 'italic' }}>
//               This certificate is certified having of authorized Lessee and IPDC Stamp is provided
//             </Typography>
//           </Paper>
//         </div>
//       </form>
//     </Box>
//   );
// }

// // ========== MAIN COMPONENT ==========
// export default function InspectionManagement() {
//   const [tabValue, setTabValue] = useState(0);
//   const [currentHandoverId, setCurrentHandoverId] = useState(null);
//   const decodedUser = useDecodedUser();
//   const [parkName, setParkName] = useState('');

//   // Fetch park name when component mounts
//   useEffect(() => {
//     const fetchParkName = async () => {
//       if (decodedUser?.park_id) {
//         try {
//           const parkData = await GetDataFromApiWithParams(`parks/${decodedUser.park_id}`, {});
//           if (parkData && parkData.name) {
//             setParkName(parkData.name);
//           } else if (parkData && typeof parkData === 'object') {
//             setParkName(parkData.name || parkData.park_name || 'Industrial Park');
//           } else {
//             setParkName('Industrial Park');
//           }
//         } catch (error) {
//           console.error("Error fetching park name:", error);
//           setParkName('Industrial Park');
//         }
//       }
//     };
//     fetchParkName();
//   }, [decodedUser]);

//   const handleTabChange = (event, newValue) => setTabValue(newValue);
  
//   const handleHandoverSaved = (handoverId) => {
//     const id = typeof handoverId === 'object' && handoverId.id ? handoverId.id : handoverId;
//     setCurrentHandoverId(id);
//     // Switch to the second tab automatically after saving handover
//     setTabValue(1);
//     toast.success("Handover registered successfully! You can now fill the handover form.", { position: "top-right" });
//   };

//   const handleFormSaved = () => {
//     toast.success("IPDC Handover form saved successfully!", { position: "top-right" });
//   };

//   return (
//     <Box sx={{ flexGrow: 1 }}>
//       <PrintStyle />
      
//       <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className="no-print">
//         <Tabs value={tabValue} onChange={handleTabChange} aria-label="inspection tabs">
//           <Tab icon={<Verified />} label="Register Handover" iconPosition="start" />
//           <Tab icon={<Assignment />} label="Land Handover Form" iconPosition="start" />
//         </Tabs>
//       </Box>

//       <TabPanel value={tabValue} index={0}>
//         <RegisterHandoverTab onHandoverSaved={handleHandoverSaved} />
//       </TabPanel>

//       <TabPanel value={tabValue} index={1}>
//         <IPDCHandoverFormTab 
//           handoverId={currentHandoverId} 
//           onSave={handleFormSaved}
//           parkName={parkName}
//         />
//       </TabPanel>
//     </Box>
//   );
// }
//******************************************************************************************** */
// import React, { useState, useEffect, useRef } from "react";
// import {
//   Box,
//   Paper,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   IconButton,
//   Button,
//   TextField,
//   InputAdornment,
//   Chip,
//   Grid,
//   Card,
//   CardContent,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   CircularProgress,
//   Tooltip,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Pagination,
//   Divider,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   Tab,
//   Tabs
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import {
//   Visibility,
//   Edit,
//   Delete,
//   Search,
//   Refresh,
//   PictureAsPdf,
//   Download,
//   CalendarToday,
//   Person,
//   Business,
//   Close,
//   Print,
//   Save,
//   Assignment,
//   VerifiedUser,
//   Group,
//   Home,
//   LocationOn,
//   ElectricalServices,
//   Handshake
// } from '@mui/icons-material';
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { 
//   GetDataFromApiWithParams, 
//   DeleteAndGetResponse,
//   ExecutePostWithParams, 
//   UpdateAndGetResponse
// } from "../../../../services/api/ExecuteApiRequests";

// // Logo paths - using public folder with full URL
// const IPDCLogo = `${window.location.origin}/IPDC_LOGO.jpg`;
// const EthiopiaLogo = `${window.location.origin}/et%20logo.png`;

// // Styled components
// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   fontWeight: 'bold',
//   backgroundColor: '#f5f5f5',
//   fontFamily: '"Times New Roman", Times, serif',
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   '&:nth-of-type(odd)': {
//     backgroundColor: '#fafafa',
//   },
//   '&:hover': {
//     backgroundColor: '#f0f0f0',
//   },
// }));

// const TimesTypography = styled(Typography)(({ theme }) => ({
//   fontFamily: '"Times New Roman", Times, serif !important',
//   color: '#000000',
// }));

// const ConsistentTableCell = styled(TableCell)(({ theme }) => ({
//   fontFamily: '"Times New Roman", Times, serif',
//   fontSize: '0.875rem',
//   color: '#000000',
// }));

// const IconText = styled('span')(({ theme }) => ({
//   fontFamily: '"Times New Roman", Times, serif',
//   fontSize: '0.875rem',
//   color: '#000000',
// }));

// // Light Gray Button Styles
// const LightGrayOutlinedButton = styled(Button)(({ theme }) => ({
//   fontFamily: '"Times New Roman", Times, serif',
//   backgroundColor: '#f0f0f0',
//   color: '#000000',
//   borderColor: '#cccccc',
//   '&:hover': {
//     backgroundColor: '#e0e0e0',
//     borderColor: '#999999',
//   },
//   '&:disabled': {
//     backgroundColor: '#e0e0e0',
//     color: '#999999',
//   }
// }));

// const LightGrayContainedButton = styled(Button)(({ theme }) => ({
//   fontFamily: '"Times New Roman", Times, serif',
//   backgroundColor: '#f0f0f0',
//   color: '#000000',
//   '&:hover': {
//     backgroundColor: '#e0e0e0',
//   },
//   '&:disabled': {
//     backgroundColor: '#e0e0e0',
//     color: '#999999',
//   }
// }));

// // Tab Panel Component
// function TabPanel({ children, value, index, ...other }) {
//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`simple-tabpanel-${index}`}
//       aria-labelledby={`simple-tab-${index}`}
//       {...other}
//     >
//       {value === index && (
//         <Box sx={{ p: 2 }}>
//           {children}
//         </Box>
//       )}
//     </div>
//   );
// }

// export default function HandoverListView() {
//   const [handovers, setHandovers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedHandover, setSelectedHandover] = useState(null);
//   const [viewDialogOpen, setViewDialogOpen] = useState(false);
//   const [editDialogOpen, setEditDialogOpen] = useState(false);
//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [filterStatus, setFilterStatus] = useState('all');
//   const [refreshing, setRefreshing] = useState(false);
//   const [editTabValue, setEditTabValue] = useState(0);
//   const [landHandoverFormData, setLandHandoverFormData] = useState(null);
//   const [editFormData, setEditFormData] = useState({
//     id: '',
//     agreement_id: '',
//     date_of_handover: '',
//     handed_over_by: '',
//     handed_over_to: '',
//     notes: '',
//     description: '',
//     park_id: '',
//     signatures: [],
//     checklist_items: []
//   });
//   const [saving, setSaving] = useState(false);
  
//   // Fetch handovers on component mount and when page/filter changes
//   useEffect(() => {
//     fetchHandovers();
//   }, [page, filterStatus]);

//   const fetchHandovers = async () => {
//     setLoading(true);
//     try {
//       const params = {
//         page: page,
//         status: filterStatus,
//         search: searchTerm
//       };
      
//       const response = await GetDataFromApiWithParams(`parks/handover`, params);
      
//       console.log("API Response:", response);
      
//       if (Array.isArray(response)) {
//         setHandovers(response);
//         setTotalPages(Math.ceil(response.length / 10) || 1);
//       } 
//       else if (response && response.data && Array.isArray(response.data)) {
//         setHandovers(response.data);
//         setTotalPages(response.totalPages || 1);
//       }
//       else {
//         console.warn("Unexpected response format:", response);
//         setHandovers([]);
//         setTotalPages(1);
//       }
//     } catch (error) {
//       console.error("Error fetching handovers:", error);
//       toast.error("Failed to load handover records", { position: "top-right" });
//       setHandovers([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch Land Handover Form data
//   const fetchLandHandoverForm = async (handoverId) => {
//     try {
//       const response = await GetDataFromApiWithParams(`parks/land-handover-form/${handoverId}`, {});
//       if (response && response.data) {
//         setLandHandoverFormData(response.data);
//         return response.data;
//       }
//       return null;
//     } catch (error) {
//       console.error("Error fetching land handover form:", error);
//       return null;
//     }
//   };

//   const handleSearch = () => {
//     setPage(1);
//     fetchHandovers();
//   };

//   const handleRefresh = async () => {
//     setRefreshing(true);
//     await fetchHandovers();
//     setRefreshing(false);
//     toast.success("Data refreshed successfully", { position: "top-right" });
//   };

//   const handleView = async (handover) => {
//     setSelectedHandover(handover);
//     await fetchLandHandoverForm(handover.id);
//     setViewDialogOpen(true);
//   };

//   const handleEdit = (handover) => {
//     console.log("Opening edit dialog for:", handover);
//     setSelectedHandover(handover);
//     setEditFormData({
//       id: handover.id || '',
//       agreement_id: handover.agreement_id || '',
//       date_of_handover: handover.date_of_handover || '',
//       handed_over_by: handover.handed_over_by || '',
//       handed_over_to: handover.handed_over_to || '',
//       notes: handover.notes || '',
//       description: handover.description || '',
//       park_id: handover.park_id || '',
//       signatures: handover.signatures || [],
//       checklist_items: handover.checklist_items || []
//     });
//     setEditTabValue(0);
//     setEditDialogOpen(true);
//   };

//   const handleEditFormChange = (e) => {
//     const { name, value } = e.target;
//     setEditFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleSignatureChange = (index, field, value) => {
//     setEditFormData(prev => {
//       const updatedSignatures = [...prev.signatures];
//       updatedSignatures[index] = {
//         ...updatedSignatures[index],
//         [field]: value
//       };
//       return {
//         ...prev,
//         signatures: updatedSignatures
//       };
//     });
//   };

//   const handleChecklistItemChange = (index, field, value) => {
//     setEditFormData(prev => {
//       const updatedItems = [...prev.checklist_items];
//       updatedItems[index] = {
//         ...updatedItems[index],
//         [field]: value
//       };
//       return {
//         ...prev,
//         checklist_items: updatedItems
//       };
//     });
//   };

//   const handleSaveEdit = async () => {
//     setSaving(true);
//     try {
//       console.log("Saving edited data:", editFormData);
//       await UpdateAndGetResponse(`parks/handover/${editFormData.id}`, editFormData);
      
//       toast.success("Handover updated successfully", { position: "top-right" });
//       setEditDialogOpen(false);
//       fetchHandovers();
//     } catch (error) {
//       console.error("Error updating handover:", error);
//       toast.error("Failed to update handover", { position: "top-right" });
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleDeleteClick = (handover) => {
//     setSelectedHandover(handover);
//     setDeleteDialogOpen(true);
//   };

//   const handleDeleteConfirm = async () => {
//     if (!selectedHandover) return;
    
//     try {
//       await DeleteAndGetResponse(`parks/handover/${selectedHandover.id}`);
//       toast.success("Handover deleted successfully", { position: "top-right" });
//       fetchHandovers();
//     } catch (error) {
//       console.error("Error deleting handover:", error);
//       toast.error("Failed to delete handover", { position: "top-right" });
//     } finally {
//       setDeleteDialogOpen(false);
//       setSelectedHandover(null);
//     }
//   };

//   // Print Land Handover Form function
//   const handlePrintLandHandoverForm = async () => {
//     if (!selectedHandover) return;
    
//     const formData = await fetchLandHandoverForm(selectedHandover.id);
    
//     const printWindow = window.open('', '_blank');
//     if (printWindow) {
//       const content = generateLandHandoverPrintContent(selectedHandover, formData);
//       printWindow.document.write(content);
//       printWindow.document.close();
//       printWindow.focus();
//       printWindow.print();
//       printWindow.close();
//     }
//   };

//   // Generate print content for Land Handover Form with header on every page
//   const generateLandHandoverPrintContent = (handover, landFormData) => {
//     const coordinates = landFormData?.coordinates || [
//       { northing: '', easting: '' },
//       { northing: '', easting: '' },
//       { northing: '', easting: '' },
//       { northing: '', easting: '' },
//       { northing: '', easting: '' },
//       { northing: '', easting: '' },
//       { northing: '', easting: '' },
//       { northing: '', easting: '' }
//     ];

//     const undergroundLines = landFormData?.undergroundLines || {
//       stormDrainage: '',
//       sewageDrainage: '',
//       wasteDrainage: '',
//       powerSupply: '',
//       telecomLine: ''
//     };

//     const lessorRep = landFormData?.lessorRepresentative || { name: '', signature: '', date: '' };
//     const lesseeRep = landFormData?.lesseeRepresentative || { name: '', signature: '', date: '' };
//     const witnesses = landFormData?.witnesses || [
//       { name: '', signature: '', date: '' },
//       { name: '', signature: '', date: '' },
//       { name: '', signature: '', date: '' }
//     ];

//     // Get the base URL from the current window location
//     const baseUrl = window.location.origin;

//     // SVG icons that match Material-UI style
//     const HomeIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1a237e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display: inline-block; vertical-align: middle; margin-right: 5px;"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2h-5v-7H9v7H5a2 2 0 0 1-2-2z"/></svg>`;
//     const LocationIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1a237e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display: inline-block; vertical-align: middle; margin-right: 5px;"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>`;
//     const ElectricalIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1a237e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display: inline-block; vertical-align: middle; margin-right: 5px;"><path d="M13 2L3 14h8l-2 8 10-12h-8l2-8z"/></svg>`;
//     const HandshakeIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1a237e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display: inline-block; vertical-align: middle; margin-right: 5px;"><path d="M17 11v2h-3v3h-2v-3H9v-3h3V8h2v3z"/><path d="M5 15l-3-7 4-2 2 4-3 5z"/><path d="M19 15l3-7-4-2-2 4 3 5z"/></svg>`;
//     const PersonIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1a237e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display: inline-block; vertical-align: middle; margin-right: 5px;"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>`;

//     return `
//       <!DOCTYPE html>
//       <html>
//         <head>
//           <title>Land Handover Form - ${handover.id}</title>
//           <meta charset="UTF-8">
//           <style>
//             * {
//               margin: 0;
//               padding: 0;
//               box-sizing: border-box;
//             }
            
//             body {
//               font-family: 'Times New Roman', Times, serif;
//               margin: 0;
//               padding: 20px;
//               color: #000000;
//               background: white;
//             }
            
//             .print-container {
//               max-width: 1100px;
//               margin: 0 auto;
//             }
            
//             /* Header Styles - appears on every page */
//             .header {
//               text-align: center;
//               margin-bottom: 30px;
//               page-break-after: avoid;
//             }
            
//             .logo-container {
//               display: flex;
//               justify-content: space-between;
//               align-items: center;
//               margin-bottom: 15px;
//             }
            
//             .logo-left, .logo-right {
//               width: 100px;
//               min-height: 80px;
//               display: flex;
//               align-items: center;
//               justify-content: center;
//             }
            
//             .logo-left img, .logo-right img {
//               max-width: 100%;
//               max-height: 80px;
//               width: auto;
//               height: auto;
//             }
            
//             .header-text {
//               flex: 1;
//               text-align: center;
//               padding: 0 20px;
//             }
            
//             .header-text h1 {
//               font-size: 16px;
//               font-weight: bold;
//               margin: 0;
//             }
            
//             .header-text h2 {
//               font-size: 14px;
//               font-weight: bold;
//               margin: 5px 0;
//             }
            
//             .header-text h3 {
//               font-size: 13px;
//               font-weight: bold;
//               text-decoration: underline;
//               margin: 10px 0 0;
//             }
            
//             .header-line {
//               border-top: 2px solid #1a237e;
//               margin: 10px 0 20px;
//             }
            
//             /* Section Styles */
//             .section {
//               margin-bottom: 20px;
//               page-break-inside: avoid;
//             }
            
//             .section-title {
//               font-size: 14px;
//               font-weight: bold;
//               color: #1a237e;
//               border-bottom: 2px solid #1a237e;
//               padding-bottom: 5px;
//               margin-bottom: 15px;
//             }
            
//             /* Grid Layouts */
//             .grid-3 {
//               display: grid;
//               grid-template-columns: repeat(3, 1fr);
//               gap: 15px;
//             }
            
//             .grid-2 {
//               display: grid;
//               grid-template-columns: repeat(2, 1fr);
//               gap: 15px;
//             }
            
//             .field {
//               margin-bottom: 10px;
//             }
            
//             .field-label {
//               font-weight: normal;
//               margin-bottom: 3px;
//             }
            
//             .field-value {
//               margin: 0;
//               padding-bottom: 5px;
//               border-bottom: 1px dotted #ccc;
//             }
            
//             /* Table Styles */
//             table {
//               width: 100%;
//               border-collapse: collapse;
//               margin-top: 10px;
//             }
            
//             th, td {
//               border: 1px solid #ddd;
//               padding: 8px;
//               text-align: left;
//             }
            
//             th {
//               background-color: #e8eaf6;
//               font-weight: bold;
//             }
            
//             /* Signature Box */
//             .signature-box {
//               border: 1px solid #ddd;
//               padding: 15px;
//               background-color: #fafafa;
//             }
            
//             .signature-box h4 {
//               margin: 0 0 10px 0;
//               font-size: 12px;
//             }
            
//             /* Empty signature line for users to sign on printed paper */
//             .signature-line {
//               border-bottom: 1px solid #000;
//               margin-top: 5px;
//               margin-bottom: 10px;
//               width: 100%;
//               height: 35px;
//             }
            
//             .signature-line-small {
//               border-bottom: 1px solid #000;
//               margin-top: 5px;
//               margin-bottom: 5px;
//               width: 100%;
//               height: 25px;
//             }
            
//             /* Footer */
//             .footer {
//               position: fixed;
//               bottom: 0;
//               left: 0;
//               right: 0;
//               text-align: center;
//               padding: 10px 0;
//               background: white;
//               border-top: 2px solid #1a237e;
//               margin-top: 20px;
//             }
            
//             .footer-text {
//               font-size: 9px;
//               text-align: center;
//               line-height: 1.4;
//             }
            
//             .footer-italic {
//               font-style: italic;
//               margin-top: 3px;
//             }
            
//             /* Page Break Control */
//             .page-break-before {
//               page-break-before: always;
//             }
            
//             .keep-together {
//               page-break-inside: avoid;
//             }
            
//             /* Print-specific styles */
//             @media print {
//               body {
//                 margin: 0;
//                 padding: 0;
//               }
//               .footer {
//                 position: fixed;
//                 bottom: 0;
//               }
//               @page {
//                 size: A4;
//                 margin: 1.5cm;
//               }
//             }
//           </style>
//         </head>
//         <body>
//           <div class="print-container">
//             <!-- Page 1 Header with Logos -->
//             <div class="header">
//               <div class="logo-container">
//                 <div class="logo-left">
//                   <img src="${EthiopiaLogo}" alt="Ethiopia Logo" />
//                 </div>
//                 <div class="header-text">
//                   <h1>THE FEDERAL DEMOCRATIC REPUBLIC OF ETHIOPIA</h1>
//                   <h2>INDUSTRIAL PARKS DEVELOPMENT CORPORATION (IPDC)</h2>
//                   <h3>HANDOVER FORM FOR ALLOCATED LAND (PLOT) TO TENANTS</h3>
//                 </div>
//                 <div class="logo-right">
//                   <img src="${IPDCLogo}" alt="IPDC Logo" />
//                 </div>
//               </div>
//               <div class="header-line"></div>
//             </div>

//             <!-- Basic Information Section -->
//             <div class="section">
//               <div class="section-title">${HomeIcon} Basic Information</div>
//               <div class="grid-3">
//                 <div class="field">
//                   <div class="field-label">Date of Handover:</div>
//                   <div class="field-value">${landFormData?.date || handover.date_of_handover || ''}</div>
//                 </div>
//                 <div class="field">
//                   <div class="field-label">Industrial Park:</div>
//                   <div class="field-value">${landFormData?.industrialPark || handover.park_id || ''}</div>
//                 </div>
//                 <div class="field">
//                   <div class="field-label">Lessee (Tenant) Name:</div>
//                   <div class="field-value">${landFormData?.lesseeName || handover.handed_over_to || ''}</div>
//                 </div>
//                 <div class="field">
//                   <div class="field-label">Title Deed Number:</div>
//                   <div class="field-value">${landFormData?.titleDeedNumber || ''}</div>
//                 </div>
//                 <div class="field">
//                   <div class="field-label">Location of Plot (Block):</div>
//                   <div class="field-value">${landFormData?.plotLocation || ''}</div>
//                 </div>
//                 <div class="field">
//                   <div class="field-label">Area of Plot (sq. meters):</div>
//                   <div class="field-value">${landFormData?.area || ''}</div>
//                 </div>
//                 <div class="field">
//                   <div class="field-label">Zoning:</div>
//                   <div class="field-value">${landFormData?.zoning || ''}</div>
//                 </div>
//                 <div class="field">
//                   <div class="field-label">For Manufacturing of:</div>
//                   <div class="field-value">${landFormData?.manufacturingFor || ''}</div>
//                 </div>
//               </div>
//             </div>

//             <!-- Coordinates of Plot -->
//             <div class="section">
//               <div class="section-title">${LocationIcon} Coordinates of Plot</div>
//               <table>
//                 <thead>
//                   <tr>
//                     <th>Point</th>
//                     <th>Northing</th>
//                     <th>Easting</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   ${coordinates.map((coord, idx) => `
//                     <tr>
//                       <td style="font-weight: bold;">${idx + 1}</td>
//                       <td>${coord.northing || ''}</td>
//                       <td>${coord.easting || ''}</td>
//                     </tr>
//                   `).join('')}
//                 </tbody>
//                burning
//             </div>

//             <!-- Underground Utility Lines - First 4 items -->
//             <div class="section">
//               <div class="section-title">${ElectricalIcon} Underground Utility Lines and Manholes</div>
//               <div class="grid-2">
//                 <div class="field">
//                   <div class="field-label">Branch Storm Drainage Line with Rectangular Concrete Cover Manhole:</div>
//                   <div class="field-value">${undergroundLines.stormDrainage || ''}</div>
//                 </div>
//                 <div class="field">
//                   <div class="field-label">Branch Sewage Drainage Line with Circular Concrete Cover Manhole:</div>
//                   <div class="field-value">${undergroundLines.sewageDrainage || ''}</div>
//                 </div>
//                 <div class="field">
//                   <div class="field-label">Branch Waste Drainage with Circular Concrete Cover Manhole:</div>
//                   <div class="field-value">${undergroundLines.wasteDrainage || ''}</div>
//                 </div>
//                 <div class="field">
//                   <div class="field-label">Power Supply Lines with Circular Steel Cover Manhole:</div>
//                   <div class="field-value">${undergroundLines.powerSupply || ''}</div>
//                 </div>
//               </div>
//             </div>

//             <!-- Page Break - Remaining items on Page 2 -->
//             <div class="page-break-before"></div>

//             <!-- Page 2 Header with Logos (repeats) -->
//             <div class="header">
//               <div class="logo-container">
//                 <div class="logo-left">
//                   <img src="${EthiopiaLogo}" alt="Ethiopia Logo" />
//                 </div>
//                 <div class="header-text">
//                   <h1>THE FEDERAL DEMOCRATIC REPUBLIC OF ETHIOPIA</h1>
//                   <h2>INDUSTRIAL PARKS DEVELOPMENT CORPORATION (IPDC)</h2>
//                   <h3>HANDOVER FORM FOR ALLOCATED LAND (PLOT) TO TENANTS</h3>
//                 </div>
//                 <div class="logo-right">
//                   <img src="${IPDCLogo}" alt="IPDC Logo" />
//                 </div>
//               </div>
//               <div class="header-line"></div>
//             </div>

//             <!-- Telecom Line (Page 2) -->
//             <div class="section">
//               <div class="section-title">${ElectricalIcon} Underground Utility Lines and Manholes (Continued)</div>
//               <div class="field">
//                 <div class="field-label">Telecom Line with Circular Steel Cover Manhole:</div>
//                 <div class="field-value">${undergroundLines.telecomLine || ''}</div>
//               </div>
//             </div>

//             <!-- Additional Infrastructure -->
//             <div class="section">
//               <div class="section-title">Additional Infrastructure</div>
//               <div class="grid-3">
//                 <div class="field">
//                   <div class="field-label">Water Supply Line:</div>
//                   <div class="field-value">${landFormData?.waterSupplyLine || ''}</div>
//                 </div>
//                 <div class="field">
//                   <div class="field-label">Location of Entrance Gate:</div>
//                   <div class="field-value">${landFormData?.entranceGate || ''}</div>
//                 </div>
//                 <div class="field">
//                   <div class="field-label">Bench Mark:</div>
//                   <div class="field-value">${landFormData?.benchMark || ''}</div>
//                 </div>
//                 <div class="field">
//                   <div class="field-label">RMU:</div>
//                   <div class="field-value">${landFormData?.rmu || ''}</div>
//                 </div>
//                 <div class="field">
//                   <div class="field-label">Walkway:</div>
//                   <div class="field-value">${landFormData?.walkway || ''}</div>
//                 </div>
//                 <div class="field">
//                   <div class="field-label">Landscape of the Plot:</div>
//                   <div class="field-value">${landFormData?.landscape || ''}</div>
//                 </div>
//               </div>
//             </div>

//             <!-- Representatives Signatures -->
//             <div class="section">
//               <div class="section-title">${HandshakeIcon} Representatives Signatures</div>
//               <div class="grid-2">
//                 <div class="signature-box">
//                   <h4>Representative of Lessor (IPDC)</h4>
//                   <div class="field">
//                     <div class="field-label">Name:</div>
//                     <div class="field-value">${lessorRep.name || '_________________________'}</div>
//                   </div>
//                   <div class="field">
//                     <div class="field-label">Signature:</div>
//                     <div class="signature-line"></div>
//                   </div>
//                   <div class="field">
//                     <div class="field-label">Date:</div>
//                     <div class="field-value">${lessorRep.date || '___________'}</div>
//                   </div>
//                 </div>
//                 <div class="signature-box">
//                   <h4>Representative of Lessee (Investor)</h4>
//                   <div class="field">
//                     <div class="field-label">Name:</div>
//                     <div class="field-value">${lesseeRep.name || '_________________________'}</div>
//                   </div>
//                   <div class="field">
//                     <div class="field-label">Signature:</div>
//                     <div class="signature-line"></div>
//                   </div>
//                   <div class="field">
//                     <div class="field-label">Date:</div>
//                     <div class="field-value">${lesseeRep.date || '___________'}</div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <!-- Witnesses -->
//             <div class="section">
//               <div class="section-title">${PersonIcon} Witnesses</div>
//               <table>
//                 <thead>
//                   <tr>
//                     <th>#</th>
//                     <th>Name</th>
//                     <th>Signature</th>
//                     <th>Date</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   ${witnesses.map((witness, idx) => `
//                     <tr>
//                       <td style="font-weight: bold;">${idx + 1}</td>
//                       <td>${witness.name || '_________________'}</td>
//                       <td><div class="signature-line-small"></div></td>
//                       <td>${witness.date || '___________'}</td>
//                     </tr>
//                   `).join('')}
//                 </tbody>
//               </table>
//             </div>

//             <!-- Footer -->
//             <div class="footer">
//               <div class="footer-text">
//                 ➢ This Handover form is prepared in four copies, one for the company, one for IPDC file, one for the Operation and Industrial Park Management and one for IP branch Office.
//               </div>
//               <div class="footer-text footer-italic">
//                 ➢ This certificate is certified having of authorized Lessee and IPDC Stamp is provided.
//               </div>
//             </div>
//           </div>
//         </body>
//       </html>
//     `;
//   };

//   const getStatusChip = (status) => {
//     const bgColorMap = {
//       'Completed': '#e0e0e0',
//       'Pending': '#f5f5f5',
//       'In Progress': '#d3d3d3',
//       'default': '#f0f0f0'
//     };
    
//     return (
//       <Chip 
//         label={status || 'Unknown'} 
//         size="small"
//         sx={{ 
//           fontFamily: '"Times New Roman", Times, serif',
//           backgroundColor: bgColorMap[status] || bgColorMap.default,
//           color: '#000000',
//           fontWeight: 400,
//           fontSize: '0.75rem',
//         }}
//       />
//     );
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric'
//     });
//   };

//   return (
//     <Box sx={{ p: 3, fontFamily: '"Times New Roman", Times, serif' }}>
//       <ToastContainer 
//         toastStyle={{ fontFamily: '"Times New Roman", Times, serif' }}
//       />
      
//       {/* Header */}
//       <Paper elevation={3} sx={{ p: 2, mb: 3 }}>
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//           <TimesTypography variant="h5" sx={{ fontWeight: 'bold' }}>
//             Handover Records
//           </TimesTypography>
//           <Box sx={{ display: 'flex', gap: 2 }}>
//             <LightGrayOutlinedButton
//               variant="outlined"
//               startIcon={<Refresh />}
//               onClick={handleRefresh}
//               disabled={refreshing}
//             >
//               {refreshing ? 'Refreshing...' : 'Refresh'}
//             </LightGrayOutlinedButton>
            
//             <LightGrayContainedButton
//               variant="contained"
//               startIcon={<PictureAsPdf />}
//             >
//               Export Report
//             </LightGrayContainedButton>
//           </Box>
//         </Box>
//       </Paper>

//       {/* Filters and Search */}
//       <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
//         <Grid container spacing={2} alignItems="center">
//           <Grid item xs={12} md={4}>
//             <TextField
//               fullWidth
//               size="small"
//               placeholder="Search by ID, Investor, or Description..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Search />
//                   </InputAdornment>
//                 ),
//                 endAdornment: searchTerm && (
//                   <InputAdornment position="end">
//                     <IconButton size="small" onClick={() => setSearchTerm('')}>
//                       <Close fontSize="small" />
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//                 style: { fontFamily: '"Times New Roman", Times, serif' }
//               }}
//             />
//           </Grid>
//           <Grid item xs={12} md={3}>
//             <FormControl fullWidth size="small">
//               <InputLabel sx={{ fontFamily: '"Times New Roman", Times, serif' }}>Status Filter</InputLabel>
//               <Select
//                 value={filterStatus}
//                 onChange={(e) => setFilterStatus(e.target.value)}
//                 label="Status Filter"
//                 sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//               >
//                 <MenuItem value="all" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>All Status</MenuItem>
//                 <MenuItem value="Completed" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>Completed</MenuItem>
//                 <MenuItem value="Pending" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>Pending</MenuItem>
//                 <MenuItem value="In Progress" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>In Progress</MenuItem>
//               </Select>
//             </FormControl>
//           </Grid>
//           <Grid item xs={12} md={2}>
//             <LightGrayContainedButton
//               variant="contained"
//               onClick={handleSearch}
//               fullWidth
//             >
//               Search
//             </LightGrayContainedButton>
//           </Grid>
//           <Grid item xs={12} md={3}>
//             <TimesTypography variant="body2" color="textSecondary">
//               Total Records: {handovers.length}
//             </TimesTypography>
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* Table */}
//       <Paper elevation={2} sx={{ width: '100%', overflow: 'hidden' }}>
//         <TableContainer sx={{ maxHeight: 500 }}>
//           <Table stickyHeader>
//             <TableHead>
//               <TableRow>
//                 <StyledTableCell>ID</StyledTableCell>
//                 <StyledTableCell>Handover Date</StyledTableCell>
//                 <StyledTableCell>Handed Over By</StyledTableCell>
//                 <StyledTableCell>Handed Over To</StyledTableCell>
//                 <StyledTableCell>Agreement ID</StyledTableCell>
//                 <StyledTableCell>Description</StyledTableCell>
//                 <StyledTableCell align="center">Actions</StyledTableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {loading ? (
//                 <TableRow>
//                   <TableCell colSpan={7} align="center" sx={{ py: 5 }}>
//                     <CircularProgress />
//                     <TimesTypography sx={{ mt: 2 }}>Loading handover records...</TimesTypography>
//                   </TableCell>
//                 </TableRow>
//               ) : handovers.length === 0 ? (
//                 <TableRow>
//                   <TableCell colSpan={7} align="center" sx={{ py: 5 }}>
//                     <TimesTypography variant="h6" color="textSecondary">
//                       No handover records found
//                     </TimesTypography>
//                   </TableCell>
//                 </TableRow>
//               ) : (
//                 handovers.map((handover) => (
//                   <StyledTableRow key={handover.id}>
//                     <ConsistentTableCell>{handover.id}</ConsistentTableCell>
//                     <ConsistentTableCell>
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                         <CalendarToday fontSize="small" sx={{ color: '#000000' }} />
//                         <IconText>{formatDate(handover.date_of_handover)}</IconText>
//                       </Box>
//                     </ConsistentTableCell>
//                     <ConsistentTableCell>
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                         <Person fontSize="small" sx={{ color: '#000000' }} />
//                         <IconText>{handover.handed_over_by}</IconText>
//                       </Box>
//                     </ConsistentTableCell>
//                     <ConsistentTableCell>
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                         <Person fontSize="small" sx={{ color: '#000000' }} /> 
//                         <IconText>{handover.handed_over_to}</IconText>
//                       </Box>
//                     </ConsistentTableCell>
//                     <ConsistentTableCell>{handover.agreement_id}</ConsistentTableCell>
//                     <ConsistentTableCell>{handover.description || "No"}</ConsistentTableCell>
//                     <ConsistentTableCell align="center">
//                       <Tooltip title="View Details">
//                         <IconButton 
//                           size="small" 
//                           sx={{ color: '#000000' }}
//                           onClick={() => handleView(handover)}
//                         >
//                           <Visibility fontSize="small" />
//                         </IconButton>
//                       </Tooltip>
//                       <Tooltip title="Edit">
//                         <IconButton 
//                           size="small" 
//                           sx={{ color: '#000000' }}
//                           onClick={() => handleEdit(handover)}
//                         >
//                           <Edit fontSize="small" />
//                         </IconButton>
//                       </Tooltip>
//                       <Tooltip title="Print Land Handover Form">
//                         <IconButton 
//                           size="small" 
//                           sx={{ color: '#000000' }}
//                           onClick={() => {
//                             setSelectedHandover(handover);
//                             handlePrintLandHandoverForm();
//                           }}
//                         >
//                           <Print fontSize="small" />
//                         </IconButton>
//                       </Tooltip>
//                       {handover.signed_document_url && (
//                         <Tooltip title="Download Document">
//                           <IconButton 
//                             size="small" 
//                             sx={{ color: '#000000' }}
//                             href={handover.signed_document_url}
//                             download
//                           >
//                             <Download fontSize="small" />
//                           </IconButton>
//                         </Tooltip>
//                       )}
//                       <Tooltip title="Delete">
//                         <IconButton 
//                           size="small" 
//                           color="error"
//                           onClick={() => handleDeleteClick(handover)}
//                         >
//                           <Delete fontSize="small" />
//                         </IconButton>
//                       </Tooltip>
//                     </ConsistentTableCell>
//                   </StyledTableRow>
//                 ))
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>
        
//         {/* Pagination */}
//         <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
//           <Pagination 
//             count={totalPages} 
//             page={page} 
//             onChange={(e, value) => setPage(value)}
//             color="primary"
//             sx={{
//               '& .MuiPaginationItem-root': {
//                 fontFamily: '"Times New Roman", Times, serif'
//               }
//             }}
//           />
//         </Box>
//       </Paper>

//       {/* View Details Dialog - Keep existing code */}
//       <Dialog 
//         open={viewDialogOpen} 
//         onClose={() => setViewDialogOpen(false)}
//         maxWidth="lg"
//         fullWidth
//       >
//         <DialogTitle sx={{ 
//           fontFamily: '"Times New Roman", Times, serif',
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center'
//         }}>
//           Handover Details - {selectedHandover?.id}
//           <Box>
//             <Tooltip title="Print Land Handover Form">
//               <IconButton onClick={handlePrintLandHandoverForm} sx={{ mr: 1 }}>
//                 <Print />
//               </IconButton>
//             </Tooltip>
//             <IconButton onClick={() => setViewDialogOpen(false)}>
//               <Close />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent dividers>
//           {selectedHandover && (
//             <Grid container spacing={3}>
//               {/* Basic Information */}
//               <Grid item xs={12}>
//                 <Card variant="outlined" sx={{ mb: 2 }}>
//                   <CardContent>
//                     <Typography variant="h6" sx={{ mb: 1.5, color: '#1a237e', borderBottom: '2px solid #1a237e', fontSize: '1rem' }}>
//                       <Home sx={{ mr: 1, fontSize: '1.2rem' }} /> Basic Information
//                     </Typography>
//                     <Divider sx={{ mb: 2 }} />
//                     <Grid container spacing={2}>
//                       <Grid item xs={12} sm={6} md={4}>
//                         <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                           Handover ID: {selectedHandover.id}
//                         </TimesTypography>
//                       </Grid>
//                       <Grid item xs={12} sm={6} md={4}>
//                         <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                           Handover Date: {formatDate(selectedHandover.date_of_handover)}
//                         </TimesTypography>
//                       </Grid>
//                       <Grid item xs={12} sm={6} md={4}>
//                         <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                           Park ID: {selectedHandover.park_id || 'N/A'}
//                         </TimesTypography>
//                       </Grid>
//                       <Grid item xs={12} sm={6} md={4}>
//                         <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                           Agreement ID: {selectedHandover.agreement_id || 'N/A'}
//                         </TimesTypography>
//                       </Grid>
//                       <Grid item xs={12} sm={6} md={4}>
//                         <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                           Handed Over By: {selectedHandover.handed_over_by || 'N/A'}
//                         </TimesTypography>
//                       </Grid>
//                       <Grid item xs={12} sm={6} md={4}>
//                         <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                           Handed Over To: {selectedHandover.handed_over_to || 'N/A'}
//                         </TimesTypography>
//                       </Grid>
//                     </Grid>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               {/* Description and Notes */}
//               <Grid item xs={12}>
//                 <Card variant="outlined" sx={{ mb: 2 }}>
//                   <CardContent>
//                     <TimesTypography variant="h6" gutterBottom sx={{ color: '#000000', fontWeight: 'normal' }}>
//                       Description & Notes
//                     </TimesTypography>
//                     <Divider sx={{ mb: 2 }} />
//                     <Grid container spacing={2}>
//                       <Grid item xs={12}>
//                         <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                           Description: {selectedHandover.description || 'No description provided'}
//                         </TimesTypography>
//                       </Grid>
//                       <Grid item xs={12}>
//                         <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                           Notes: {selectedHandover.notes || 'No notes provided'}
//                         </TimesTypography>
//                       </Grid>
//                       {selectedHandover.attachment_paths && (
//                         <Grid item xs={12}>
//                           <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                             Attachment: {selectedHandover.attachment_paths}
//                           </TimesTypography>
//                           <Button
//                             variant="outlined"
//                             startIcon={<Download />}
//                             href={selectedHandover.attachment_paths}
//                             target="_blank"
//                             size="small"
//                             sx={{ 
//                               mt: 1, 
//                               fontFamily: '"Times New Roman", Times, serif',
//                               color: '#000000',
//                               borderColor: '#cccccc'
//                             }}
//                           >
//                             Download Attachment
//                           </Button>
//                         </Grid>
//                       )}
//                     </Grid>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               {/* Land Handover Form Data Section */}
//               {landHandoverFormData && (
//                 <>
//                   {/* Plot Information */}
//                   <Grid item xs={12}>
//                     <Card variant="outlined" sx={{ mb: 2 }}>
//                       <CardContent>
//                         <Typography variant="h6" sx={{ mb: 1.5, color: '#1a237e', borderBottom: '2px solid #1a237e', fontSize: '1rem' }}>
//                           <LocationOn sx={{ mr: 1, fontSize: '1.2rem' }} /> Plot Information
//                         </Typography>
//                         <Divider sx={{ mb: 2 }} />
//                         <Grid container spacing={2}>
//                           <Grid item xs={12} sm={6} md={4}>
//                             <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                               Lessee Name: {landHandoverFormData.lesseeName || 'N/A'}
//                             </TimesTypography>
//                           </Grid>
//                           <Grid item xs={12} sm={6} md={4}>
//                             <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                               Title Deed Number: {landHandoverFormData.titleDeedNumber || 'N/A'}
//                             </TimesTypography>
//                           </Grid>
//                           <Grid item xs={12} sm={6} md={4}>
//                             <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                               Plot Location: {landHandoverFormData.plotLocation || 'N/A'}
//                             </TimesTypography>
//                           </Grid>
//                           <Grid item xs={12} sm={6} md={4}>
//                             <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                               Area: {landHandoverFormData.area || 'N/A'} sq. meters
//                             </TimesTypography>
//                           </Grid>
//                           <Grid item xs={12} sm={6} md={4}>
//                             <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                               Zoning: {landHandoverFormData.zoning || 'N/A'}
//                             </TimesTypography>
//                           </Grid>
//                           <Grid item xs={12} sm={6} md={4}>
//                             <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                               Manufacturing For: {landHandoverFormData.manufacturingFor || 'N/A'}
//                             </TimesTypography>
//                           </Grid>
//                         </Grid>
//                       </CardContent>
//                     </Card>
//                   </Grid>

//                   {/* Coordinates */}
//                   {landHandoverFormData.coordinates && (
//                     <Grid item xs={12}>
//                       <Card variant="outlined" sx={{ mb: 2 }}>
//                         <CardContent>
//                           <Typography variant="h6" sx={{ mb: 1.5, color: '#1a237e', borderBottom: '2px solid #1a237e', fontSize: '1rem' }}>
//                             <LocationOn sx={{ mr: 1, fontSize: '1.2rem' }} /> Coordinates of Plot (8 Points)
//                           </Typography>
//                           <Divider sx={{ mb: 2 }} />
//                           <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 400 }}>
//                             <Table size="small" stickyHeader>
//                               <TableHead>
//                                 <TableRow sx={{ backgroundColor: '#e8eaf6' }}>
//                                   <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>Point</TableCell>
//                                   <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>Northing (X)</TableCell>
//                                   <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>Easting (Y)</TableCell>
//                                 </TableRow>
//                               </TableHead>
//                               <TableBody>
//                                 {landHandoverFormData.coordinates.map((coord, idx) => (
//                                   <TableRow key={idx}>
//                                     <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif' }}>{idx + 1}</TableCell>
//                                     <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif' }}>{coord.northing || ''}</TableCell>
//                                     <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif' }}>{coord.easting || ''}</TableCell>
//                                   </TableRow>
//                                 ))}
//                               </TableBody>
//                             </Table>
//                           </TableContainer>
//                         </CardContent>
//                       </Card>
//                     </Grid>
//                   )}

//                   {/* Utility Lines */}
//                   {landHandoverFormData.undergroundLines && (
//                     <Grid item xs={12}>
//                       <Card variant="outlined" sx={{ mb: 2 }}>
//                         <CardContent>
//                           <Typography variant="h6" sx={{ mb: 1.5, color: '#1a237e', borderBottom: '2px solid #1a237e', fontSize: '1rem' }}>
//                             <ElectricalServices sx={{ mr: 1, fontSize: '1.2rem' }} /> Underground Utility Lines and Manholes
//                           </Typography>
//                           <Divider sx={{ mb: 2 }} />
//                           <Grid container spacing={2}>
//                             <Grid item xs={12} sm={6}>
//                               <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                 Storm Drainage: {landHandoverFormData.undergroundLines.stormDrainage || 'N/A'}
//                               </TimesTypography>
//                             </Grid>
//                             <Grid item xs={12} sm={6}>
//                               <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                 Sewage Drainage: {landHandoverFormData.undergroundLines.sewageDrainage || 'N/A'}
//                               </TimesTypography>
//                             </Grid>
//                             <Grid item xs={12} sm={6}>
//                               <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                 Waste Drainage: {landHandoverFormData.undergroundLines.wasteDrainage || 'N/A'}
//                               </TimesTypography>
//                             </Grid>
//                             <Grid item xs={12} sm={6}>
//                               <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                 Power Supply: {landHandoverFormData.undergroundLines.powerSupply || 'N/A'}
//                               </TimesTypography>
//                             </Grid>
//                             <Grid item xs={12} sm={6}>
//                               <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                 Telecom Line: {landHandoverFormData.undergroundLines.telecomLine || 'N/A'}
//                               </TimesTypography>
//                             </Grid>
//                           </Grid>
//                         </CardContent>
//                       </Card>
//                     </Grid>
//                   )}

//                   {/* Additional Infrastructure */}
//                   <Grid item xs={12}>
//                     <Card variant="outlined" sx={{ mb: 2 }}>
//                       <CardContent>
//                         <TimesTypography variant="h6" gutterBottom sx={{ color: '#000000', fontWeight: 'normal' }}>
//                           Additional Infrastructure
//                         </TimesTypography>
//                         <Divider sx={{ mb: 2 }} />
//                         <Grid container spacing={2}>
//                           <Grid item xs={12} sm={4}>
//                             <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                               Water Supply Line: {landHandoverFormData.waterSupplyLine || 'N/A'}
//                             </TimesTypography>
//                           </Grid>
//                           <Grid item xs={12} sm={4}>
//                             <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                               Entrance Gate: {landHandoverFormData.entranceGate || 'N/A'}
//                             </TimesTypography>
//                           </Grid>
//                           <Grid item xs={12} sm={4}>
//                             <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                               Bench Mark: {landHandoverFormData.benchMark || 'N/A'}
//                             </TimesTypography>
//                           </Grid>
//                           <Grid item xs={12} sm={4}>
//                             <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                               RMU: {landHandoverFormData.rmu || 'N/A'}
//                             </TimesTypography>
//                           </Grid>
//                           <Grid item xs={12} sm={4}>
//                             <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                               Walkway: {landHandoverFormData.walkway || 'N/A'}
//                             </TimesTypography>
//                           </Grid>
//                           <Grid item xs={12} sm={4}>
//                             <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                               Landscape: {landHandoverFormData.landscape || 'N/A'}
//                             </TimesTypography>
//                           </Grid>
//                         </Grid>
//                       </CardContent>
//                     </Card>
//                   </Grid>

//                   {/* Signatures */}
//                   <Grid item xs={12}>
//                     <Card variant="outlined" sx={{ mb: 2 }}>
//                       <CardContent>
//                         <Typography variant="h6" sx={{ mb: 1.5, color: '#1a237e', borderBottom: '2px solid #1a237e', fontSize: '1rem' }}>
//                           <Handshake sx={{ mr: 1, fontSize: '1.2rem' }} /> Representatives Signatures
//                         </Typography>
//                         <Divider sx={{ mb: 2 }} />
//                         <Grid container spacing={2}>
//                           <Grid item xs={12} md={6}>
//                             <Paper variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
//                               <TimesTypography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
//                                 Representative of Lessor (IPDC)
//                               </TimesTypography>
//                               <TimesTypography variant="body2">Name: {landHandoverFormData.lessorRepresentative?.name || 'N/A'}</TimesTypography>
//                               <TimesTypography variant="body2">Signature: {landHandoverFormData.lessorRepresentative?.signature ? '(Signature on file)' : 'N/A'}</TimesTypography>
//                               <TimesTypography variant="body2">Date: {landHandoverFormData.lessorRepresentative?.date || 'N/A'}</TimesTypography>
//                             </Paper>
//                           </Grid>
//                           <Grid item xs={12} md={6}>
//                             <Paper variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
//                               <TimesTypography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
//                                 Representative of Lessee (Investor)
//                               </TimesTypography>
//                               <TimesTypography variant="body2">Name: {landHandoverFormData.lesseeRepresentative?.name || 'N/A'}</TimesTypography>
//                               <TimesTypography variant="body2">Signature: {landHandoverFormData.lesseeRepresentative?.signature ? '(Signature on file)' : 'N/A'}</TimesTypography>
//                               <TimesTypography variant="body2">Date: {landHandoverFormData.lesseeRepresentative?.date || 'N/A'}</TimesTypography>
//                             </Paper>
//                           </Grid>
//                         </Grid>
//                       </CardContent>
//                     </Card>
//                   </Grid>

//                   {/* Witnesses */}
//                   {landHandoverFormData.witnesses && (
//                     <Grid item xs={12}>
//                       <Card variant="outlined" sx={{ mb: 2 }}>
//                         <CardContent>
//                           <Typography variant="h6" sx={{ mb: 1.5, color: '#1a237e', borderBottom: '2px solid #1a237e', fontSize: '1rem' }}>
//                             <Person sx={{ mr: 1, fontSize: '1.2rem' }} /> Witnesses
//                           </Typography>
//                           <Divider sx={{ mb: 2 }} />
//                           <TableContainer component={Paper} variant="outlined">
//                             <Table size="small">
//                               <TableHead>
//                                 <TableRow sx={{ backgroundColor: '#e8eaf6' }}>
//                                   <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>#</TableCell>
//                                   <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>Name</TableCell>
//                                   <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>Signature</TableCell>
//                                   <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>Date</TableCell>
//                                 </TableRow>
//                               </TableHead>
//                               <TableBody>
//                                 {landHandoverFormData.witnesses.map((witness, idx) => (
//                                   <TableRow key={idx}>
//                                     <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif' }}>{idx + 1}</TableCell>
//                                     <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif' }}>{witness.name || 'N/A'}</TableCell>
//                                     <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif' }}>{witness.signature ? '(Signature on file)' : 'N/A'}</TableCell>
//                                     <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif' }}>{witness.date || 'N/A'}</TableCell>
//                                   </TableRow>
//                                 ))}
//                               </TableBody>
//                             </Table>
//                           </TableContainer>
//                         </CardContent>
//                       </Card>
//                     </Grid>
//                   )}
//                 </>
//               )}

//               {/* Signatures Section from handover */}
//               {selectedHandover.signatures && selectedHandover.signatures.length > 0 && !landHandoverFormData && (
//                 <Grid item xs={12}>
//                   <Card variant="outlined" sx={{ mb: 2 }}>
//                     <CardContent>
//                       <TimesTypography variant="h6" gutterBottom sx={{ color: '#000000', fontWeight: 'normal' }}>
//                         Signatures & Witnesses
//                       </TimesTypography>
//                       <Divider sx={{ mb: 2 }} />
//                       {selectedHandover.signatures.map((sig, index) => (
//                         <Box key={index} sx={{ mt: 2 }}>
//                           <Grid container spacing={2}>
//                             <Grid item xs={12} md={4}>
//                               <Paper variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
//                                 <TimesTypography variant="subtitle2" gutterBottom sx={{ color: '#000000' }}>
//                                   IPDC Vice E & Technic Manager
//                                 </TimesTypography>
//                                 <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                   Name: {sig.ipdc_vice_name || 'N/A'}
//                                 </TimesTypography>
//                                 <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                   Position: {sig.ipdc_vice_position || 'N/A'}
//                                 </TimesTypography>
//                                 <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                   Date: {formatDate(sig.ipdc_vice_date)}
//                                 </TimesTypography>
//                               </Paper>
//                             </Grid>
//                             <Grid item xs={12} md={4}>
//                               <Paper variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
//                                 <TimesTypography variant="subtitle2" gutterBottom sx={{ color: '#000000' }}>
//                                   Investor Company
//                                 </TimesTypography>
//                                 <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                   Name: {sig.investor_name || 'N/A'}
//                                 </TimesTypography>
//                                 <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                   Position: {sig.investor_position || 'N/A'}
//                                 </TimesTypography>
//                                 <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                   Date: {formatDate(sig.investor_date)}
//                                 </TimesTypography>
//                               </Paper>
//                             </Grid>
//                             <Grid item xs={12} md={4}>
//                               <Paper variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
//                                 <TimesTypography variant="subtitle2" gutterBottom sx={{ color: '#000000' }}>
//                                   IPDC KISEZ Manager
//                                 </TimesTypography>
//                                 <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                   Name: {sig.ipdc_kisez_name || 'N/A'}
//                                 </TimesTypography>
//                                 <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                   Position: {sig.ipdc_kisez_position || 'N/A'}
//                                 </TimesTypography>
//                                 <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                   Date: {formatDate(sig.ipdc_kisez_date)}
//                                 </TimesTypography>
//                               </Paper>
//                             </Grid>
//                             <Grid item xs={12}>
//                               <Paper variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9', mt: 1 }}>
//                                 <TimesTypography variant="subtitle2" gutterBottom sx={{ color: '#000000' }}>
//                                   Witnesses
//                                 </TimesTypography>
//                                 <Grid container spacing={2}>
//                                   <Grid item xs={12} sm={4}>
//                                     <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                       Witness 1: {sig.witness1_name || 'N/A'}
//                                     </TimesTypography>
//                                   </Grid>
//                                   <Grid item xs={12} sm={4}>
//                                     <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                       Witness 2: {sig.witness2_name || 'N/A'}
//                                     </TimesTypography>
//                                   </Grid>
//                                   <Grid item xs={12} sm={4}>
//                                     <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                       Witness 3: {sig.witness3_name || 'N/A'}
//                                     </TimesTypography>
//                                   </Grid>
//                                 </Grid>
//                               </Paper>
//                             </Grid>
//                           </Grid>
//                         </Box>
//                       ))}
//                     </CardContent>
//                   </Card>
//                 </Grid>
//               )}

//               {/* Checklist Items Section */}
//               {selectedHandover.checklist_items && selectedHandover.checklist_items.length > 0 && (
//                 <Grid item xs={12}>
//                   <Card variant="outlined">
//                     <CardContent>
//                       <TimesTypography variant="h6" gutterBottom sx={{ color: '#000000', fontWeight: 'normal' }}>
//                         Checklist Items ({selectedHandover.checklist_items.length})
//                       </TimesTypography>
//                       <Divider sx={{ mb: 2 }} />
//                       <TableContainer component={Paper} variant="outlined" sx={{ mt: 2, maxHeight: 300 }}>
//                         <Table size="small" stickyHeader>
//                           <TableHead>
//                             <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
//                               <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000', fontWeight: 'bold' }}>No.</TableCell>
//                               <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000', fontWeight: 'bold' }}>Item Name</TableCell>
//                               <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000', fontWeight: 'bold' }}>Status</TableCell>
//                               <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000', fontWeight: 'bold' }}>Accept/Reject</TableCell>
//                               <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000', fontWeight: 'bold' }}>Remarks</TableCell>
//                             </TableRow>
//                           </TableHead>
//                           <TableBody>
//                             {selectedHandover.checklist_items.map((item) => (
//                               <TableRow key={item.id}>
//                                 <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000' }}>{item.inspection_no}</TableCell>
//                                 <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000' }}>{item.item_name}</TableCell>
//                                 <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000' }}>{item.status || 'N/A'}</TableCell>
//                                 <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000' }}>
//                                   <Chip 
//                                     label={item.accept_reject || 'Pending'} 
//                                     size="small"
//                                     sx={{
//                                       fontFamily: '"Times New Roman", Times, serif',
//                                       backgroundColor: 
//                                         item.accept_reject === 'Accept' ? '#e0e0e0' : 
//                                         item.accept_reject === 'Reject' ? '#e0e0e0' : 
//                                         '#f5f5f5',
//                                       color: '#000000'
//                                     }}
//                                   />
//                                 </TableCell>
//                                 <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000' }}>{item.remarks || 'N/A'}</TableCell>
//                               </TableRow>
//                             ))}
//                           </TableBody>
//                         </Table>
//                       </TableContainer>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//               )}
//             </Grid>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <LightGrayOutlinedButton onClick={() => setViewDialogOpen(false)}>
//             Close
//           </LightGrayOutlinedButton>
//         </DialogActions>
//       </Dialog>

//       {/* Edit Handover Dialog - Keep existing code */}
//       <Dialog 
//         open={editDialogOpen} 
//         onClose={() => setEditDialogOpen(false)}
//         maxWidth="lg"
//         fullWidth
//       >
//         <DialogTitle sx={{ 
//           fontFamily: '"Times New Roman", Times, serif',
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center'
//         }}>
//           Edit Handover - {editFormData.id}
//           <IconButton onClick={() => setEditDialogOpen(false)}>
//             <Close />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent dividers>
//           <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
//             <Tabs 
//               value={editTabValue} 
//               onChange={(e, newValue) => setEditTabValue(newValue)}
//               aria-label="edit handover tabs"
//             >
//               <Tab 
//                 icon={<Business />} 
//                 label="Basic Info" 
//                 iconPosition="start"
//                 sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//               />
//               <Tab 
//                 icon={<VerifiedUser />} 
//                 label="Signatures" 
//                 iconPosition="start"
//                 sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//               />
//               <Tab 
//                 icon={<Assignment />} 
//                 label="Checklist Items" 
//                 iconPosition="start"
//                 sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//               />
//             </Tabs>
//           </Box>

//           {/* Basic Information Tab */}
//           <TabPanel value={editTabValue} index={0}>
//             <Grid container spacing={2}>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Agreement ID"
//                   name="agreement_id"
//                   value={editFormData.agreement_id}
//                   onChange={handleEditFormChange}
//                   sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//                   InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                   inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Handover Date"
//                   name="date_of_handover"
//                   type="date"
//                   value={editFormData.date_of_handover}
//                   onChange={handleEditFormChange}
//                   InputLabelProps={{ shrink: true, sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                   sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//                   inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Handed Over By"
//                   name="handed_over_by"
//                   value={editFormData.handed_over_by}
//                   onChange={handleEditFormChange}
//                   sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//                   InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                   inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Handed Over To"
//                   name="handed_over_to"
//                   value={editFormData.handed_over_to}
//                   onChange={handleEditFormChange}
//                   sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//                   InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                   inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Park ID"
//                   name="park_id"
//                   value={editFormData.park_id}
//                   onChange={handleEditFormChange}
//                   sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//                   InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                   inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Description"
//                   name="description"
//                   multiline
//                   rows={2}
//                   value={editFormData.description}
//                   onChange={handleEditFormChange}
//                   sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//                   InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                   inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Notes"
//                   name="notes"
//                   multiline
//                   rows={2}
//                   value={editFormData.notes}
//                   onChange={handleEditFormChange}
//                   sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//                   InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                   inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                 />
//               </Grid>
//             </Grid>
//           </TabPanel>

//           {/* Signatures Tab */}
//           <TabPanel value={editTabValue} index={1}>
//             {editFormData.signatures && editFormData.signatures.length > 0 ? (
//               editFormData.signatures.map((sig, index) => (
//                 <Accordion key={index} defaultExpanded={index === 0}>
//                   <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//                     <Typography sx={{ fontFamily: '"Times New Roman", Times, serif' }}>
//                       Signature Set {index + 1}
//                     </Typography>
//                   </AccordionSummary>
//                   <AccordionDetails>
//                     <Grid container spacing={2}>
//                       <Grid item xs={12} md={4}>
//                         <Card variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
//                           <Typography variant="subtitle2" gutterBottom sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>
//                             IPDC Vice E & Technic Manager
//                           </Typography>
//                           <TextField
//                             fullWidth
//                             size="small"
//                             label="Name"
//                             value={sig.ipdc_vice_name || ''}
//                             onChange={(e) => handleSignatureChange(index, 'ipdc_vice_name', e.target.value)}
//                             sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
//                             InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                           <TextField
//                             fullWidth
//                             size="small"
//                             label="Position"
//                             value={sig.ipdc_vice_position || ''}
//                             onChange={(e) => handleSignatureChange(index, 'ipdc_vice_position', e.target.value)}
//                             sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
//                             InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                           <TextField
//                             fullWidth
//                             size="small"
//                             label="Signature"
//                             value={sig.ipdc_vice_signature || ''}
//                             onChange={(e) => handleSignatureChange(index, 'ipdc_vice_signature', e.target.value)}
//                             sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
//                             InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                           <TextField
//                             fullWidth
//                             size="small"
//                             label="Date"
//                             type="date"
//                             value={sig.ipdc_vice_date || ''}
//                             onChange={(e) => handleSignatureChange(index, 'ipdc_vice_date', e.target.value)}
//                             InputLabelProps={{ shrink: true, sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                             sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                         </Card>
//                       </Grid>

//                       <Grid item xs={12} md={4}>
//                         <Card variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
//                           <Typography variant="subtitle2" gutterBottom sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>
//                             Investor Company
//                           </Typography>
//                           <TextField
//                             fullWidth
//                             size="small"
//                             label="Name"
//                             value={sig.investor_name || ''}
//                             onChange={(e) => handleSignatureChange(index, 'investor_name', e.target.value)}
//                             sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
//                             InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                           <TextField
//                             fullWidth
//                             size="small"
//                             label="Position"
//                             value={sig.investor_position || ''}
//                             onChange={(e) => handleSignatureChange(index, 'investor_position', e.target.value)}
//                             sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
//                             InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                           <TextField
//                             fullWidth
//                             size="small"
//                             label="Signature"
//                             value={sig.investor_signature || ''}
//                             onChange={(e) => handleSignatureChange(index, 'investor_signature', e.target.value)}
//                             sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
//                             InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                           <TextField
//                             fullWidth
//                             size="small"
//                             label="Date"
//                             type="date"
//                             value={sig.investor_date || ''}
//                             onChange={(e) => handleSignatureChange(index, 'investor_date', e.target.value)}
//                             InputLabelProps={{ shrink: true, sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                             sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                         </Card>
//                       </Grid>

//                       <Grid item xs={12} md={4}>
//                         <Card variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
//                           <Typography variant="subtitle2" gutterBottom sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>
//                             IPDC KISEZ Manager
//                           </Typography>
//                           <TextField
//                             fullWidth
//                             size="small"
//                             label="Name"
//                             value={sig.ipdc_kisez_name || ''}
//                             onChange={(e) => handleSignatureChange(index, 'ipdc_kisez_name', e.target.value)}
//                             sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
//                             InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                           <TextField
//                             fullWidth
//                             size="small"
//                             label="Position"
//                             value={sig.ipdc_kisez_position || ''}
//                             onChange={(e) => handleSignatureChange(index, 'ipdc_kisez_position', e.target.value)}
//                             sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
//                             InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                           <TextField
//                             fullWidth
//                             size="small"
//                             label="Signature"
//                             value={sig.ipdc_kisez_signature || ''}
//                             onChange={(e) => handleSignatureChange(index, 'ipdc_kisez_signature', e.target.value)}
//                             sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
//                             InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                           <TextField
//                             fullWidth
//                             size="small"
//                             label="Date"
//                             type="date"
//                             value={sig.ipdc_kisez_date || ''}
//                             onChange={(e) => handleSignatureChange(index, 'ipdc_kisez_date', e.target.value)}
//                             InputLabelProps={{ shrink: true, sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                             sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                         </Card>
//                       </Grid>

//                       <Grid item xs={12}>
//                         <Card variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
//                           <Typography variant="subtitle2" gutterBottom sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>
//                             Witnesses
//                           </Typography>
//                           <Grid container spacing={2}>
//                             <Grid item xs={12} sm={4}>
//                               <TextField
//                                 fullWidth
//                                 size="small"
//                                 label="Witness 1"
//                                 value={sig.witness1_name || ''}
//                                 onChange={(e) => handleSignatureChange(index, 'witness1_name', e.target.value)}
//                                 sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//                                 InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                                 inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                               />
//                             </Grid>
//                             <Grid item xs={12} sm={4}>
//                               <TextField
//                                 fullWidth
//                                 size="small"
//                                 label="Witness 2"
//                                 value={sig.witness2_name || ''}
//                                 onChange={(e) => handleSignatureChange(index, 'witness2_name', e.target.value)}
//                                 sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//                                 InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                                 inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                               />
//                             </Grid>
//                             <Grid item xs={12} sm={4}>
//                               <TextField
//                                 fullWidth
//                                 size="small"
//                                 label="Witness 3"
//                                 value={sig.witness3_name || ''}
//                                 onChange={(e) => handleSignatureChange(index, 'witness3_name', e.target.value)}
//                                 sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//                                 InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                                 inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                               />
//                             </Grid>
//                           </Grid>
//                         </Card>
//                       </Grid>
//                     </Grid>
//                   </AccordionDetails>
//                 </Accordion>
//               ))
//             ) : (
//               <Typography sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#999' }}>
//                 No signature data available
//               </Typography>
//             )}
//           </TabPanel>

//           {/* Checklist Items Tab */}
//           <TabPanel value={editTabValue} index={2}>
//             {editFormData.checklist_items && editFormData.checklist_items.length > 0 ? (
//               <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 400 }}>
//                 <Table size="small" stickyHeader>
//                   <TableHead>
//                     <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
//                       <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>No.</TableCell>
//                       <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>Item Name</TableCell>
//                       <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>Status</TableCell>
//                       <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>Accept/Reject</TableCell>
//                       <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>Remarks</TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {editFormData.checklist_items.map((item, index) => (
//                       <TableRow key={item.id || index}>
//                         <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif' }}>{item.inspection_no}</TableCell>
//                         <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif' }}>{item.item_name}</TableCell>
//                         <TableCell>
//                           <TextField
//                             size="small"
//                             value={item.status || ''}
//                             onChange={(e) => handleChecklistItemChange(index, 'status', e.target.value)}
//                             sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                         </TableCell>
//                         <TableCell>
//                           <Select
//                             size="small"
//                             value={item.accept_reject || 'Pending'}
//                             onChange={(e) => handleChecklistItemChange(index, 'accept_reject', e.target.value)}
//                             sx={{ fontFamily: '"Times New Roman", Times, serif', minWidth: 100 }}
//                           >
//                             <MenuItem value="Accept" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>Accept</MenuItem>
//                             <MenuItem value="Reject" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>Reject</MenuItem>
//                             <MenuItem value="Pending" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>Pending</MenuItem>
//                           </Select>
//                         </TableCell>
//                         <TableCell>
//                           <TextField
//                             size="small"
//                             value={item.remarks || ''}
//                             onChange={(e) => handleChecklistItemChange(index, 'remarks', e.target.value)}
//                             sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             ) : (
//               <Typography sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#999' }}>
//                 No checklist items available
//               </Typography>
//             )}
//           </TabPanel>
//         </DialogContent>
//         <DialogActions>
//           <LightGrayOutlinedButton onClick={() => setEditDialogOpen(false)}>
//             Cancel
//           </LightGrayOutlinedButton>
//           <Button 
//             onClick={handleSaveEdit}
//             variant="contained"
//             disabled={saving}
//             startIcon={saving ? <CircularProgress size={20} /> : <Save />}
//             sx={{ 
//               fontFamily: '"Times New Roman", Times, serif',
//               backgroundColor: '#f0f0f0',
//               color: '#000000',
//               '&:hover': {
//                 backgroundColor: '#e0e0e0',
//               }
//             }}
//           >
//             {saving ? 'Saving...' : 'Save Changes'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Delete Confirmation Dialog */}
//       <Dialog
//         open={deleteDialogOpen}
//         onClose={() => setDeleteDialogOpen(false)}
//       >
//         <DialogTitle sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000' }}>
//           Confirm Delete
//         </DialogTitle>
//         <DialogContent>
//           <TimesTypography sx={{ color: '#000000' }}>
//             Are you sure you want to delete handover record{' '}
//             {selectedHandover?.id}? This action cannot be undone.
//           </TimesTypography>
//         </DialogContent>
//         <DialogActions>
//           <LightGrayOutlinedButton onClick={() => setDeleteDialogOpen(false)}>
//             Cancel
//           </LightGrayOutlinedButton>
//           <Button 
//             onClick={handleDeleteConfirm}
//             color="error"
//             variant="contained"
//             sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//           >
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// }
//********************************************************* */
//******************************************* */
import React, { useState, useEffect, useRef } from "react";
import { 
  Home, List, Logout, Map, Print, Report, Handshake,
  SettingsAccessibility, CheckCircle, Warning, Error,
  Description, Save, Assignment, Verified, Person,
  BusinessCenter, CalendarToday, SquareFoot,
  LocationOn, ElectricalServices, Edit, Download
} from "@mui/icons-material";
import {
  Box,
  Paper,
  Typography,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  IconButton,
  Button,
  TextField,
  MenuItem,
  Select,
  FormControl,
  Divider,
  Grid,
  Card,
  CardContent,
  Tabs,
  Tab,
  AppBar,
  Toolbar,
  Container,
  CircularProgress,
  Input
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Import your custom components
import FormContainer from "../../../../components/Forms/FormContainer";
import useDecodedUser from "../../../../services/hooks/useDecodedUser";
import { ExecutePostWithParams, GetDataFromApiWithParams } from "../../../../services/api/ExecuteApiRequests";
import { IPDCFormattedJsonToDisplay } from "../../../../components/Controls";

// Use public folder path for logo (no import needed)
const IPDCLogo = "/IPDC_LOGO.jpg";
const EthiopiaLogo = "/et logo.png";

// ========== STYLED COMPONENTS ==========
const TimesTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    fontFamily: '"Times New Roman", Times, serif',
    fontSize: '0.875rem',
    fontWeight: 400,
  },
  '& .MuiInputLabel-root': {
    fontFamily: '"Times New Roman", Times, serif',
    fontSize: '0.875rem',
    fontWeight: 400,
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': { borderWidth: '1px' },
    '&:hover fieldset': { borderWidth: '1px' },
    '&.Mui-focused fieldset': { borderWidth: '1px' },
  },
}));

const TimesTypography = styled(Typography)(({ theme }) => ({
  fontFamily: '"Times New Roman", Times, serif !important',
}));

const TimesInput = styled(Input)(({ theme }) => ({
  '& .MuiInputBase-input': {
    fontFamily: '"Times New Roman", Times, serif',
    fontSize: '0.875rem',
    padding: '8.5px 14px',
  },
}));

const ThinDivider = styled('div')(({ theme }) => ({
  height: '1px',
  backgroundColor: '#e0e0e0',
  margin: '8px 0',
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 'bold',
  backgroundColor: '#f5f5f5',
  fontFamily: '"Times New Roman", Times, serif',
}));

// Print styles with header on every page
const PrintStyle = () => (
  <style type="text/css" media="print">
    {`
      @media print {
        .no-print {
          display: none !important;
        }
        .print-header {
          display: block !important;
        }
        .print-footer {
          display: block !important;
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          text-align: center;
          padding: 10px 0;
          background: white;
        }
        body {
          margin: 0;
          padding: 0;
        }
        .MuiPaper-root {
          box-shadow: none !important;
          border: none !important;
        }
        button {
          display: none !important;
        }
        .MuiButton-root {
          display: none !important;
        }
        .MuiIconButton-root {
          display: none !important;
        }
        .MuiTabs-root {
          display: none !important;
        }
        .MuiTab-root {
          display: none !important;
        }
        .MuiAppBar-root {
          display: none !important;
        }
        header {
          display: none !important;
        }
        nav {
          display: none !important;
        }
        .sidebar {
          display: none !important;
        }
        .MuiDrawer-root {
          display: none !important;
        }
        .MuiToolbar-root {
          display: none !important;
        }
        @page {
          size: A4;
          margin: 1.5cm;
        }
        
        /* Page break control */
        .page-break-before {
          page-break-before: always;
        }
        
        .keep-together {
          page-break-inside: avoid;
        }
      }
    `}
  </style>
);

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

// ========== TAB 1: REGISTER HANDOVER ==========
function RegisterHandoverTab({ onHandoverSaved }) {
  const decodedUser = useDecodedUser();
  const [formData, setFormData] = useState({
    agreement_id: "",
    handover_date: new Date().toISOString().split("T")[0],
    handedover_by: "",
    handedover_to: "",
    notes: "",
    signed_document_path: "",
    description: "",
    park_id: "",
  });
  const [selectedAgreement, setSelectedAgreement] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isUserLoading, setIsUserLoading] = useState(true);
  const [agreementsList, setAgreementsList] = useState([]);

  useEffect(() => {
    if (decodedUser) {
      setIsUserLoading(false);
      setFormData(prev => ({
        ...prev,
        handedover_by: decodedUser.full_name || "",
        park_id: decodedUser.park_id || ""
      }));
      
      const fetchAgreements = async () => {
        try {
          const params = { park_id: decodedUser.park_id, type: 'Land Leased' };
          const agreData = await GetDataFromApiWithParams(`parks/getAgreementByType`, params);
          const agreDataArray = Array.isArray(agreData) ? agreData : 
                      (agreData && agreData.data && Array.isArray(agreData.data)) ? agreData.data :
                      (agreData && typeof agreData === 'object') ? [agreData] : [];
          setAgreementsList(agreDataArray);
        } catch (error) {
          console.error("Error fetching agreements:", error);
          setAgreementsList([]);
        }
      };
      fetchAgreements();
    }
  }, [decodedUser]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFormData(prev => ({ ...prev, signed_document_path: file }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    if (!selectedAgreement?.id) {
      toast.error("Please select an agreement", { position: "top-right" });
      return;
    }
  
    if (!formData.handedover_to.trim()) {
      toast.error("Please enter who the handover is being given to", { position: "top-right" });
      return;
    }
  
    setIsLoading(true);
    
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("agreement_id", selectedAgreement.id);
      formDataToSend.append("handover_date", formData.handover_date);
      formDataToSend.append("handedover_by", decodedUser?.full_name || "");
      formDataToSend.append("handedover_to", formData.handedover_to);
      formDataToSend.append("notes", formData.notes || "");
      formDataToSend.append("description", formData.description || "");
      formDataToSend.append("park_id", decodedUser?.park_id || "");
      
      if (formData.signed_document_path) {
        formDataToSend.append("file", formData.signed_document_path);
      }
      
      const result = await ExecutePostWithParams(`parks/handover`, formDataToSend, true);
      
      if (result) {
        const handoverId = result[0]?.id || result.id || result;
        setFormData({
          agreement_id: "",
          handover_date: new Date().toISOString().split("T")[0],
          handedover_by: decodedUser?.full_name || "",
          handedover_to: "",
          notes: "",
          signed_document_path: "",
          description: "",
          park_id: decodedUser?.park_id || "",
        });
        setSelectedAgreement(null);
        const fileInput = document.querySelector('input[type="file"]');
        if (fileInput) fileInput.value = '';
        if (onHandoverSaved) onHandoverSaved(handoverId);
        toast.success("Handover registered successfully!", { position: "top-right" });
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to register handover", { position: "top-right" });
    } finally {
      setIsLoading(false);
    }
  };

  if (isUserLoading) {
    return (
      <Container>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <CircularProgress size={24} />
          <TimesTypography sx={{ ml: 2 }}>Loading...</TimesTypography>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg">
      <ToastContainer />
      <FormContainer title="Register Handover Details" onSubmit={handleSubmit}>
        <Grid container spacing={1.5}>
          <Grid item xs={12} md={6}>
            <Grid container spacing={1.5}>
              <Grid item xs={12}>
                <FormControl fullWidth size="small" sx={{ mb: 1 }}>
                  <InputLabel sx={{ fontFamily: '"Times New Roman", Times, serif', fontSize: '0.8rem' }}>
                    Select Agreement
                  </InputLabel>
                  <Select
                    value={selectedAgreement ? selectedAgreement.id : ''}
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      const agreement = agreementsList.find(ag => ag.id === selectedId);
                      setSelectedAgreement(agreement || null);
                    }}
                    label="Select Agreement"
                    sx={{
                      fontFamily: '"Times New Roman", Times, serif',
                      fontSize: '0.8rem',
                      height: '32px',
                      '& .MuiSelect-select': { padding: '6px 10px' }
                    }}
                  >
                    <MenuItem value="" sx={{ fontFamily: '"Times New Roman", Times, serif', fontSize: '0.8rem' }}>
                      <em>None</em>
                    </MenuItem>
                    {agreementsList.map((agreement) => (
                      <MenuItem 
                        key={agreement.id} 
                        value={agreement.id}
                        sx={{ fontFamily: '"Times New Roman", Times, serif', fontSize: '0.8rem', whiteSpace: 'normal', py: 0.5 }}
                      >
                        {agreement?.name || agreement?.agreement_no || agreement?.id}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <ThinDivider />
              </Grid>
              
              <Grid item xs={12}>
                <TimesTextField
                  label="Handover Date"
                  type="date"
                  name="handover_date"
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  value={formData.handover_date}
                  onChange={handleChange}
                  required
                  disabled={isLoading}
                />
              </Grid>
              
              <Grid item xs={12}>
                <TimesTextField
                  label="Handed Over By"
                  name="handedover_by"
                  fullWidth
                  size="small"
                  value={formData.handedover_by}
                  disabled
                />
              </Grid>
              
              <Grid item xs={12}>
                <TimesTextField
                  label="Handed Over To"
                  name="handedover_to"
                  fullWidth
                  size="small"
                  value={formData.handedover_to}
                  onChange={handleChange}
                  required
                  disabled={isLoading}
                />
              </Grid>
              
              <Grid item xs={12}>
                <TimesTextField
                  label="Notes"
                  name="notes"
                  fullWidth
                  size="small"
                  value={formData.notes}
                  onChange={handleChange}
                  disabled={isLoading}
                  multiline
                  rows={1}
                />
              </Grid>
              
              <Grid item xs={12}>
                <TimesTypography variant="subtitle2" sx={{ mb: 0.5, fontWeight: 400 }}>
                  Signed Document
                </TimesTypography>
                <TimesInput
                  type="file"
                  fullWidth
                  size="small"
                  disabled={isLoading}
                  inputProps={{ accept: "application/pdf,image/*" }}
                  onChange={handleFileChange}
                />
                <TimesTypography variant="caption" color="textSecondary" sx={{ mt: 0.5, display: 'block' }}>
                  Accepts PDF or image files
                </TimesTypography>
                <ThinDivider />
              </Grid>
              
              <Grid item xs={12}>
                <TimesTextField
                  label="Description"
                  name="description"
                  fullWidth
                  size="small"
                  value={formData.description}
                  onChange={handleChange}
                  disabled={isLoading}
                  multiline
                  rows={2}
                />
              </Grid>
            </Grid>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Box sx={{ height: "100%", border: '1px solid #e0e0e0', borderRadius: 0.5, p: 1.5, backgroundColor: '#fafafa' }}>
              <TimesTypography variant="h6" align="center" gutterBottom sx={{ fontSize: '0.9375rem', fontWeight: 300, mb: 1.5 }}>
                Agreement Details
              </TimesTypography>
              {selectedAgreement ? (
                <Box sx={{ height: '450px', overflow: 'auto' }}>
                  <IPDCFormattedJsonToDisplay data={selectedAgreement} height="450px" />
                </Box>
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '450px', border: '1px dashed #bdbdbd', borderRadius: 0.5, backgroundColor: '#ffffff' }}>
                  <TimesTypography color="textSecondary" sx={{ fontSize: '0.8125rem', fontStyle: 'italic' }}>
                    Select an agreement *
                  </TimesTypography>
                </Box>
              )}
            </Box>
          </Grid>
          
          <Grid item xs={12}>
            <Button 
              type="submit"
              variant="contained" 
              color="primary"
              fullWidth
              disabled={isLoading}
              startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : <Save />}
              className="no-print"
            >
              {isLoading ? "Saving..." : "Register Handover"}
            </Button>
          </Grid>
        </Grid>
      </FormContainer>
    </Container>
  );
}

// ========== TAB 2: IPDC HANDOVER FORM (PRINTABLE VERSION) ==========
function IPDCHandoverFormTab({ handoverId, onSave, parkName, initialData }) {
  const [formData, setFormData] = useState({
    id: '',
    date: new Date().toISOString().split("T")[0],
    industrialPark: parkName || 'Loading...',
    lesseeName: '',
    titleDeedNumber: '',
    plotLocation: '',
    coordinates: [
      { northing: '', easting: '' },
      { northing: '', easting: '' },
      { northing: '', easting: '' },
      { northing: '', easting: '' },
      { northing: '', easting: '' },
      { northing: '', easting: '' },
      { northing: '', easting: '' },
      { northing: '', easting: '' }
    ],
    area: '',
    zoning: '',
    manufacturingFor: '',
    undergroundLines: {
      stormDrainage: '',
      sewageDrainage: '',
      wasteDrainage: '',
      powerSupply: '',
      telecomLine: ''
    },
    waterSupplyLine: '',
    entranceGate: '',
    benchMark: '',
    rmu: '',
    walkway: '',
    landscape: '',
    lessorRepresentative: {
      name: '',
      signature: '',
      date: ''
    },
    lesseeRepresentative: {
      name: '',
      signature: '',
      date: ''
    },
    witnesses: [
      { name: '', signature: '', date: '' },
      { name: '', signature: '', date: '' },
      { name: '', signature: '', date: '' }
    ]
  });

  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const printRef = useRef();

  // Load existing data if editing
  useEffect(() => {
    if (initialData) {
      setFormData(prev => ({
        ...prev,
        ...initialData,
        industrialPark: parkName || initialData.industrialPark || 'Industrial Park'
      }));
    }
  }, [initialData, parkName]);

  // Fetch existing form data if handoverId is provided
  useEffect(() => {
    const fetchFormData = async () => {
      if (handoverId && !initialData) {
        setIsLoading(true);
        try {
          const response = await GetDataFromApiWithParams(`parks/land-handover-form/${handoverId}`, {});
          if (response && response.data) {
            setFormData(prev => ({
              ...prev,
              ...response.data,
              industrialPark: parkName || response.data.industrialPark || 'Industrial Park'
            }));
          }
        } catch (error) {
          console.error("Error fetching form data:", error);
        } finally {
          setIsLoading(false);
        }
      }
    };
    fetchFormData();
  }, [handoverId, parkName, initialData]);

  // Update park name when it changes
  useEffect(() => {
    if (parkName) {
      setFormData(prev => ({ ...prev, industrialPark: parkName }));
    }
  }, [parkName]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleCoordinateChange = (index, field, value) => {
    const updatedCoordinates = [...formData.coordinates];
    updatedCoordinates[index][field] = value;
    setFormData(prev => ({ ...prev, coordinates: updatedCoordinates }));
  };

  const handleUndergroundLineChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      undergroundLines: { ...prev.undergroundLines, [field]: value }
    }));
  };

  const handleRepresentativeChange = (type, field, value) => {
    setFormData(prev => ({
      ...prev,
      [type]: { ...prev[type], [field]: value }
    }));
  };

  const handleWitnessChange = (index, field, value) => {
    const updatedWitnesses = [...formData.witnesses];
    updatedWitnesses[index][field] = value;
    setFormData(prev => ({ ...prev, witnesses: updatedWitnesses }));
  };

  const handlePrint = () => {
    window.print();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!handoverId) {
      toast.error("Please save handover details first", { position: "top-right" });
      return;
    }
    
    setIsSaving(true);
    try {
      const submitData = {
        handover_id: handoverId,
        date: formData.date,
        lesseeName: formData.lesseeName,
        titleDeedNumber: formData.titleDeedNumber,
        plotLocation: formData.plotLocation,
        area: formData.area,
        zoning: formData.zoning,
        manufacturingFor: formData.manufacturingFor,
        coordinates: formData.coordinates,
        undergroundLines: formData.undergroundLines,
        waterSupplyLine: formData.waterSupplyLine,
        entranceGate: formData.entranceGate,
        benchMark: formData.benchMark,
        rmu: formData.rmu,
        walkway: formData.walkway,
        landscape: formData.landscape,
        lessorRepresentative: formData.lessorRepresentative,
        lesseeRepresentative: formData.lesseeRepresentative,
        witnesses: formData.witnesses
      };
      
      await ExecutePostWithParams(`parks/land-handover-form`, submitData);
      toast.success("IPDC Handover form saved successfully!", { position: "top-right" });
      if (onSave) onSave();
    } catch (error) {
      console.error("Error saving IPDC handover:", error);
      toast.error("Failed to save IPDC handover: " + (error.message || "Unknown error"), { position: "top-right" });
    } finally {
      setIsSaving(false);
    }
  };

  // Print header component - appears on every page when printing
  const PrintHeader = () => (
    <div className="print-header" style={{ display: 'block', marginBottom: '20px' }}>
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        width: '100%',
        mb: 2,
        pb: 1,
        borderBottom: '2px solid #1a237e'
      }}>
        <Box sx={{ width: '80px' }}>
          <img src={EthiopiaLogo} alt="Ethiopia Logo" style={{ width: '100%', height: 'auto' }} />
        </Box>
        <Box sx={{ textAlign: 'center', flex: 1, px: 2 }}>
          <Typography variant="h5" sx={{ fontWeight: 'bold', fontFamily: '"Times New Roman", Times, serif', fontSize: '14pt' }}>
            THE FEDERAL DEMOCRATIC REPUBLIC OF ETHIOPIA
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 'bold', fontFamily: '"Times New Roman", Times, serif', fontSize: '12pt', mt: 0.5 }}>
            INDUSTRIAL PARKS DEVELOPMENT CORPORATION (IPDC)
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 'bold', fontFamily: '"Times New Roman", Times, serif', textDecoration: 'underline', mt: 1, fontSize: '11pt' }}>
            HANDOVER FORM FOR ALLOCATED LAND (PLOT) TO TENANTS
          </Typography>
        </Box>
        <Box sx={{ width: '80px' }}>
          <img src={IPDCLogo} alt="IPDC Logo" style={{ width: '100%', height: 'auto' }} />
        </Box>
      </Box>
    </div>
  );

  // Print footer component - appears on every page when printing
  const PrintFooter = () => (
    <div className="print-footer" style={{ display: 'block' }}>
      <Divider sx={{ mb: 1, borderColor: '#1a237e', borderWidth: 1.5 }} />
      <Typography 
        variant="body2" 
        sx={{ 
          fontFamily: '"Times New Roman", Times, serif',
          fontSize: '9pt',
          lineHeight: 1.3,
          color: '#333',
          textAlign: 'center'
        }}
      >
        ➢ This Handover form is prepared in four copies, one for the company, one for IPDC file, one for the Operation and Industrial Park Management and one for IP branch Office.
      </Typography>
      <Typography 
        variant="body2" 
        sx={{ 
          fontFamily: '"Times New Roman", Times, serif',
          fontSize: '9pt',
          lineHeight: 1.3,
          color: '#333',
          textAlign: 'center',
          fontStyle: 'italic',
          mt: 0.5
        }}
      >
        ➢ This certificate is certified having of authorized Lessee and IPDC Stamp is provided.
      </Typography>
    </div>
  );

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2, maxWidth: 1100, margin: '0 auto' }}>
      <PrintStyle />
      
      {/* Action Buttons - Hidden when printing */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2, gap: 2 }} className="no-print">
        <Button variant="outlined" startIcon={<Print />} onClick={handlePrint}>
          Print Form
        </Button>
        <Button variant="outlined" startIcon={<Download />}>
          Export PDF
        </Button>
      </Box>

      <form onSubmit={handleSubmit}>
        <div ref={printRef}>
          {/* Section 1: Basic Information */}
          <PrintHeader />
          
          <Card sx={{ mb: 1.5, pageBreakInside: 'avoid' }}>
            <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
              <Typography variant="h6" sx={{ mb: 1.5, color: '#1a237e', borderBottom: '2px solid #1a237e', fontSize: '1rem' }}>
                <Home sx={{ mr: 1, fontSize: '1.2rem' }} /> Basic Information
              </Typography>
              <Grid container spacing={1.5}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Date of Handover"
                    name="date"
                    type="date"
                    value={formData.date}
                    onChange={handleInputChange}
                    InputLabelProps={{ shrink: true }}
                    required
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Industrial Park"
                    name="industrialPark"
                    value={formData.industrialPark}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Lessee (Tenant) Name"
                    name="lesseeName"
                    value={formData.lesseeName}
                    onChange={handleInputChange}
                    required
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Title Deed Number"
                    name="titleDeedNumber"
                    value={formData.titleDeedNumber}
                    onChange={handleInputChange}
                    required
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Location of Plot (Block)"
                    name="plotLocation"
                    value={formData.plotLocation}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Area of Plot (sq. meters)"
                    name="area"
                    value={formData.area}
                    onChange={handleInputChange}
                    placeholder="sq. meters"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Zoning"
                    name="zoning"
                    value={formData.zoning}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="For Manufacturing of"
                    name="manufacturingFor"
                    value={formData.manufacturingFor}
                    onChange={handleInputChange}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* Section 2: Coordinates - All 8 points visible */}
          <Card sx={{ mb: 1.5, pageBreakInside: 'avoid' }}>
            <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
              <Typography variant="h6" sx={{ mb: 1.5, color: '#1a237e', borderBottom: '2px solid #1a237e', fontSize: '1rem' }}>
                <LocationOn sx={{ mr: 1, fontSize: '1.2rem' }} /> Coordinates of Plot (8 Points)
              </Typography>
              <TableContainer component={Paper} variant="outlined">
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ bgcolor: '#e8eaf6' }}>
                      <TableCell sx={{ fontWeight: 'bold', width: '70px', py: 0.5 }}>Point</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', py: 0.5 }}>Northing (X)</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', py: 0.5 }}>Easting (Y)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {formData.coordinates.map((coord, index) => (
                      <TableRow key={index}>
                        <TableCell sx={{ fontWeight: 'bold', py: 0.5 }}>Point {index + 1}</TableCell>
                        <TableCell sx={{ py: 0.5 }}>
                          <TextField
                            fullWidth
                            size="small"
                            value={coord.northing}
                            onChange={(e) => handleCoordinateChange(index, 'northing', e.target.value)}
                            placeholder={`Northing ${index + 1}`}
                          />
                        </TableCell>
                        <TableCell sx={{ py: 0.5 }}>
                          <TextField
                            fullWidth
                            size="small"
                            value={coord.easting}
                            onChange={(e) => handleCoordinateChange(index, 'easting', e.target.value)}
                            placeholder={`Easting ${index + 1}`}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>

          {/* Section 3: Utilities and Infrastructure - First Part (stays on page 1) */}
          <Card sx={{ mb: 1.5, pageBreakInside: 'avoid' }}>
            <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
              <Typography variant="h6" sx={{ mb: 1.5, color: '#1a237e', borderBottom: '2px solid #1a237e', fontSize: '1rem' }}>
                <ElectricalServices sx={{ mr: 1, fontSize: '1.2rem' }} /> Underground Utility Lines and Manholes
              </Typography>
              <Grid container spacing={1}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Branch Storm Drainage Line with Rectangular Concrete Cover Manhole"
                    value={formData.undergroundLines.stormDrainage}
                    onChange={(e) => handleUndergroundLineChange('stormDrainage', e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Branch Sewage Drainage Line with Circular Concrete Cover Manhole"
                    value={formData.undergroundLines.sewageDrainage}
                    onChange={(e) => handleUndergroundLineChange('sewageDrainage', e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Branch Waste Drainage with Circular Concrete Cover Manhole"
                    value={formData.undergroundLines.wasteDrainage}
                    onChange={(e) => handleUndergroundLineChange('wasteDrainage', e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Power Supply Lines with Circular Steel Cover Manhole"
                    value={formData.undergroundLines.powerSupply}
                    onChange={(e) => handleUndergroundLineChange('powerSupply', e.target.value)}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* Page Break - Telecom Line will start on page 2 */}
          <div className="page-break-before" style={{ pageBreakBefore: 'always' }}></div>

          {/* Section 3B: Telecom Line (starts on page 2) */}
          <PrintHeader />
          
          <Card sx={{ mb: 1.5, pageBreakInside: 'avoid' }}>
            <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
              <Typography variant="h6" sx={{ mb: 1.5, color: '#1a237e', borderBottom: '2px solid #1a237e', fontSize: '1rem' }}>
                <ElectricalServices sx={{ mr: 1, fontSize: '1.2rem' }} /> Underground Utility Lines and Manholes (Continued)
              </Typography>
              <Grid container spacing={1}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Telecom Line with Circular Steel Cover Manhole"
                    value={formData.undergroundLines.telecomLine}
                    onChange={(e) => handleUndergroundLineChange('telecomLine', e.target.value)}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* Section 4: Additional Infrastructure */}
          <Card sx={{ mb: 1.5, pageBreakInside: 'avoid' }}>
            <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
              <Typography variant="h6" sx={{ mb: 1.5, color: '#1a237e', borderBottom: '2px solid #1a237e', fontSize: '1rem' }}>
                Additional Infrastructure
              </Typography>
              <Grid container spacing={1}>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Water Supply Line"
                    value={formData.waterSupplyLine}
                    onChange={(e) => setFormData({...formData, waterSupplyLine: e.target.value})}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Location of Entrance Gate"
                    value={formData.entranceGate}
                    onChange={(e) => setFormData({...formData, entranceGate: e.target.value})}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Bench Mark"
                    value={formData.benchMark}
                    onChange={(e) => setFormData({...formData, benchMark: e.target.value})}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="RMU"
                    value={formData.rmu}
                    onChange={(e) => setFormData({...formData, rmu: e.target.value})}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Walkway"
                    value={formData.walkway}
                    onChange={(e) => setFormData({...formData, walkway: e.target.value})}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Landscape of the Plot"
                    value={formData.landscape}
                    onChange={(e) => setFormData({...formData, landscape: e.target.value})}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* Section 5: Signatures - Read Only */}
          <Card sx={{ mb: 1.5, pageBreakInside: 'avoid' }}>
            <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
              <Typography variant="h6" sx={{ mb: 1.5, color: '#1a237e', borderBottom: '2px solid #1a237e', fontSize: '1rem' }}>
                <Handshake sx={{ mr: 1, fontSize: '1.2rem' }} /> Representatives Signatures
              </Typography>
              <Grid container spacing={1.5}>
                <Grid item xs={12} md={6}>
                  <Paper variant="outlined" sx={{ p: 1, bgcolor: '#fafafa' }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
                      Representative of Lessor (IPDC)
                    </Typography>
                    <TextField
                      fullWidth
                      size="small"
                      label="Name"
                      value={formData.lessorRepresentative.name}
                      onChange={(e) => handleRepresentativeChange('lessorRepresentative', 'name', e.target.value)}
                      sx={{ mb: 1 }}
                    />
                    <TextField
                      fullWidth
                      size="small"
                      label="Signature"
                      value={formData.lessorRepresentative.signature}
                      InputProps={{ readOnly: true }}
                      sx={{ mb: 1 }}
                      className="no-print"
                    />
                    <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 1, fontStyle: 'italic' }} className="print-only">
                      (Signature on file)
                    </Typography>
                    <TextField
                      fullWidth
                      size="small"
                      label="Date"
                      type="date"
                      value={formData.lessorRepresentative.date}
                      onChange={(e) => handleRepresentativeChange('lessorRepresentative', 'date', e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Paper>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Paper variant="outlined" sx={{ p: 1, bgcolor: '#fafafa' }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
                      Representative of Lessee (Investor)
                    </Typography>
                    <TextField
                      fullWidth
                      size="small"
                      label="Name"
                      value={formData.lesseeRepresentative.name}
                      onChange={(e) => handleRepresentativeChange('lesseeRepresentative', 'name', e.target.value)}
                      sx={{ mb: 1 }}
                    />
                    <TextField
                      fullWidth
                      size="small"
                      label="Signature"
                      value={formData.lesseeRepresentative.signature}
                      InputProps={{ readOnly: true }}
                      sx={{ mb: 1 }}
                      className="no-print"
                    />
                    <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 1, fontStyle: 'italic' }} className="print-only">
                      (Signature on file)
                    </Typography>
                    <TextField
                      fullWidth
                      size="small"
                      label="Date"
                      type="date"
                      value={formData.lesseeRepresentative.date}
                      onChange={(e) => handleRepresentativeChange('lesseeRepresentative', 'date', e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Paper>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* Section 6: Witnesses */}
          <Card sx={{ mb: 1.5, pageBreakInside: 'avoid' }}>
            <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
              <Typography variant="h6" sx={{ mb: 1.5, color: '#1a237e', borderBottom: '2px solid #1a237e', fontSize: '1rem' }}>
                <Person sx={{ mr: 1, fontSize: '1.2rem' }} /> Witnesses
              </Typography>
              <TableContainer component={Paper} variant="outlined">
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ bgcolor: '#e8eaf6' }}>
                      <TableCell sx={{ fontWeight: 'bold', width: '90px', py: 0.5 }}>#</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', py: 0.5 }}>Name</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', py: 0.5 }}>Signature</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', py: 0.5 }}>Date</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {formData.witnesses.map((witness, index) => (
                      <TableRow key={index}>
                        <TableCell sx={{ py: 0.5 }}>Witness {index + 1}</TableCell>
                        <TableCell sx={{ py: 0.5 }}>
                          <TextField
                            fullWidth
                            size="small"
                            value={witness.name}
                            onChange={(e) => handleWitnessChange(index, 'name', e.target.value)}
                          />
                        </TableCell>
                        <TableCell sx={{ py: 0.5 }}>
                          <TextField
                            fullWidth
                            size="small"
                            value={witness.signature}
                            InputProps={{ readOnly: true }}
                            className="no-print"
                          />
                          <Typography variant="caption" color="textSecondary" sx={{ display: 'none' }} className="print-only">
                            (Signature on file)
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ py: 0.5 }}>
                          <TextField
                            fullWidth
                            size="small"
                            type="date"
                            value={witness.date}
                            onChange={(e) => handleWitnessChange(index, 'date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>

          {/* Footer appears on every page */}
          <PrintFooter />

          {/* Submit Button - Below the form (screen only) */}
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3, mb: 2 }} className="no-print">
            <Button
              type="submit"
              variant="contained"
              size="large"
              disabled={isSaving || !handoverId}
              startIcon={isSaving ? <CircularProgress size={20} color="inherit" /> : <Save />}
              sx={{ 
                fontFamily: '"Times New Roman", Times, serif',
                bgcolor: '#1a237e', 
                '&:hover': { bgcolor: '#283593' },
                minWidth: 280,
                py: 1.2,
                fontSize: '1rem'
              }}
            >
              {isSaving ? "Saving..." : "SUBMIT HANDOVER FORM"}
            </Button>
          </Box>
          
          {!handoverId && (
            <Typography sx={{ color: 'error.main', fontSize: '0.875rem', textAlign: 'center', mb: 2 }} className="no-print">
              Please register handover details in Tab 1 first to enable saving this form
            </Typography>
          )}
        </div>
      </form>
    </Box>
  );
}

// ========== MAIN COMPONENT ==========
export default function InspectionManagement() {
  const [tabValue, setTabValue] = useState(0);
  const [currentHandoverId, setCurrentHandoverId] = useState(null);
  const decodedUser = useDecodedUser();
  const [parkName, setParkName] = useState('');

  // Fetch park name when component mounts
  useEffect(() => {
    const fetchParkName = async () => {
      if (decodedUser?.park_id) {
        try {
          const parkData = await GetDataFromApiWithParams(`parks/${decodedUser.park_id}`, {});
          if (parkData && parkData.name) {
            setParkName(parkData.name);
          } else if (parkData && typeof parkData === 'object') {
            setParkName(parkData.name || parkData.park_name || 'Industrial Park');
          } else {
            setParkName('Industrial Park');
          }
        } catch (error) {
          console.error("Error fetching park name:", error);
          setParkName('Industrial Park');
        }
      }
    };
    fetchParkName();
  }, [decodedUser]);

  const handleTabChange = (event, newValue) => setTabValue(newValue);
  
  const handleHandoverSaved = (handoverId) => {
    const id = typeof handoverId === 'object' && handoverId.id ? handoverId.id : handoverId;
    setCurrentHandoverId(id);
    setTabValue(1);
    toast.success("Handover registered successfully! You can now fill the handover form.", { position: "top-right" });
  };

  const handleFormSaved = () => {
    toast.success("IPDC Handover form saved successfully!", { position: "top-right" });
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <PrintStyle />
      
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className="no-print">
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="inspection tabs">
          <Tab icon={<Verified />} label="Register Handover" iconPosition="start" />
          <Tab icon={<Assignment />} label="Land Handover Form" iconPosition="start" />
        </Tabs>
      </Box>

      <TabPanel value={tabValue} index={0}>
        <RegisterHandoverTab onHandoverSaved={handleHandoverSaved} />
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <IPDCHandoverFormTab 
          handoverId={currentHandoverId} 
          onSave={handleFormSaved}
          parkName={parkName}
        />
      </TabPanel>
    </Box>
  );
}